/** user permissions, for now hard coded in here. */
export interface Permissions {
	/**  Shows the dimensions management pages */
	MANAGE_DIMENSION: string;
	/**  Allow the user to get all users. */
	USER_GET_ALL: string;
	/**  Allow the user to create a new user. */
	USER_CREATE: string;
	/**  Allow the user to edit an existing user. */
	USER_EDIT: string;
	/**  Allow the user to delete a user. */
	USER_DELETE: string;
	/**  Allow the user to change his user settings. */
	USER_SETTINGS: string;
	/**  Allow the user to get all groups. */
	GROUP_GET_ALL: string;
	/**  Allow the user to create a new group. */
	GROUP_CREATE: string;
	/**  Allow the user to edit an existing group. */
	GROUP_EDIT: string;
	/**  Allow the user to delete a group. */
	GROUP_DELETE: string;
	/** Allow the user to add and remove a user from one or multiple groups */
	USER_GROUP_UPDATE_USER: string;

	AP_VIEW_APPLICATION_LOGS: string;

	/** Access reports */
	REPORTS_BI: string;
	/** Edit reports */
	REPORTS_BI_EDIT: string;
	/** Show the reporting menu item */
	REPORTS_MENU_ITEM: string;
	/** Manage reporting datasources */
	REPORTS_DATASOURCES: string;
	/** Repository push (private) */
	REPORTS_PUSH: string;
	/** Repository fetch */
	REPORTS_FETCH: string;
	/** Repository update */
	REPORTS_UPDATE: string;
	/** Update downstream */
	REPORTS_UPDATE_DOWNSTREAM: string;
	/** Make public */
	REPORTS_MAKE_PUBLIC: string;
	/** Manage organisation IDs */
	REPORTS_MNG_ORGANISATION_IDS: string;
	/** Manage reporting settings */
	REPORTS_MNG_SETTINGS: string;

	REPORTS_NOTIFICATION_TEMPLATES_READ: string;
	REPORTS_NOTIFICATION_TEMPLATES_CREATE: string;
	REPORTS_NOTIFICATION_TEMPLATES_UPDATE: string;
	REPORTS_NOTIFICATION_TEMPLATES_DELETE: string;

	REPORTS_NOTIFICATION_RUNS_READ: string;
	REPORTS_NOTIFICATION_RUNS_CREATE: string;
	REPORTS_NOTIFICATION_RUNS_UPDATE: string;
	REPORTS_NOTIFICATION_RUNS_DELETE: string;

	REPORTS_NOTIFICATION_NOTIFICATION_READ: string;
	REPORTS_NOTIFICATION_NOTIFICATION_UPDATE: string;
	REPORTS_NOTIFICATION_NOTIFICATION_DELETE: string;
	REPORTS_NOTIFICATION_NOTIFICATION_IGNORE: string;

	DATASOURCES: string;
	DATASOURCES_EDIT: string;
	DATASOURCES_CREATE: string;

	DASHBOARD_ACCESS: string;
	AUTHORIZATIONS_ACCESS: string;
	REQUISITION_AUTH_ACCESS: string;
	DRAFTS_ACCESS: string;
	PURCHASE_ORDER_ACCESS: string;
	DEBIT_BATCH_ACCESS: string;
	DEBIT_BATCH_AUTHORIZATIONS_ACCESS: string;
	REQUISITION_ACCESS: string;
	ADVANCED_PROCUREMENT_ACCESS: string;
	OVERVIEWS_ACCESS: string;
	DELEGATES_ACCESS: string;
	WORKFLOWS_ACCESS: string;
	DELEGATION_MANAGER_ACCESS: string;
	REPORTS_ACCESS: string;
	EPO_SYSTEM_ADMIN: string;

	LICENSE_ACCESS: string;
	AS_UM_MI_USER_MANAGEMENT_MENU_ITEM: string;
	AS_UM_MI_USERS: string;
	AS_UM_MI_GROUPS: string;
	AS_UM_MI_SESSION_MANAGEMENT_MENU_ITEM: string;
	AS_UM_MI_SESSION_MANAGEMENT_SETTINGS: string;
	AS_UM_MI_SESSION_MANAGEMENT: string;
	MANAGEMENT_PORTAL_ACCESS: string;

	AP_MANAGE_MENU_ITEM: string;

	TIP_MI_DMS_OVERVIEW: string;

	FTP_MENU_ITEM: string;
	FTP_SERVER_READ: string;
	FTP_SERVER_TEST_CONNECTION: string;
	FTP_SERVER_CREATE: string;
	FTP_SERVER_DELETE: string;
	FTP_SERVER_UPDATE: string;

	// Connected apps
	AP_MANAGE_APPS: string;
	AP_MANAGE_APP_USERS: string;
	AP_CREATE_APPS: string;
	AP_ACCESS_ALL_COMPANY_APPS: string;
	AP_MANAGE_ALL_COMPANY_APPS: string;

	// Companies
	AP_MANAGE_COMPANIES: string;
	AP_MANAGE_COMPANY_USERS: string;
	AP_CREATE_COMPANIES: string;
	AP_ACCESS_ALL_ORGANISATION_COMPANIES: string;
	AP_MANAGE_ALL_ORGANISATION_COMPANIES: string;

	AP_ADD_ALL_ORGANISATION_USERS: string;

	// Organisations
	AP_MANAGE_ORGANISATIONS: string;
	AP_INVITE_ORGANISATION_USERS: string;
	AP_MANAGE_ORGANISATION_USERS: string;
	AP_CREATE_ORGANISATIONS: string;

	// Quick Setup
	AP_CREATE_SETUP: string;

	// Database management
	AP_CREATE_DATABASE: string;
	AP_COPY_DATABASE: string;

	// Application types
	AP_MANAGE_APPLICATION_TYPES: string;

	// Audit logs
	AP_VIEW_AUDIT_LOGS: string;

	AP_VIEW_INCIDENT_LOGS: string;
	AP_FETCH_API_STATUSSES: string;

	AP_MANAGE_PORTAL_SETTINGS: string;

	// DMS
	TIP_DMS_DELETE: string;
	TIP_DMS_EDIT: string;

	// User management
	AP_APPROVE_REJECT_USERS: string;
	AP_USER_APPROVAL_ORGANISATION: string;
	AP_USER_APPROVAL: string;

	TIP_MANAGE_DOCUMENT_CATEGORIES: string;

	TIP_VIEW_ALL_INVESTOR: string;
	TIP_VIEW_COMPANY_INVESTOR: string;
	TIP_CREATE_COMPANY_INVESTOR: string;
	TIP_EDIT_COMPANY_INVESTOR: string;
	TIP_DELETE_COMPANY_INVESTOR: string;
	TIP_MANAGE_INVESTOR_USER: string;

	// DMS2
	DMS_UPLOAD_DOCUMENT: string;
	DMS_DELETE_DOCUMENT: string;
	DMS_EDIT_DOCUMENT: string;
	DMS_DOWNLOAD_DOCUMENT: string;

	DMS_MANAGE_RECORD_TYPES: string;
	DMS_MANAGE_CATEGORIES: string;
	DMS_MANAGE_BASKETS: string;
	DMS_MANAGE_BASKET_DOWNLOADS: string;

	// Loan creation
	LC_MANAGE_CHECKLISTS: string;
	LC_SUBMIT_LOANS: string;
	LC_EDIT_ON_APPROVAL: string;

	//Transaction import
	TI_CANCEL_IMPORT: string;
	TI_CREATE_IMPORT: string;
	TI_APPROVE_IMPORT: string;
	TI_PROCESS_IMPORT: string;
	TI_RETRIEVE_IMPORT: string;
	TI_VALIDATE_IMPORT: string;

	// EVO online
	EVO_VIEW_CUSTOMER: string;
	EVO_MANAGE_CUSTOMER: string;
	EVO_VIEW_SUPPLIER: string;
	EVO_MANAGE_SUPPLIER: string;
	EVO_VIEW_GL_ACCOUNT: string;
	EVO_MANAGE_GL_ACCOUNT: string;
	EVO_VIEW_CASHBOOK_BATCH: string;
	EVO_SAVE_CASHBOOK_BATCH: string;
	EVO_VALIDATE_CASHBOOK_BATCH: string;
	EVO_PROCESS_CASHBOOK_BATCH: string;
	EVO_VIEW_BANK_STATEMENT: string;
	EVO_IMPORT_BANK_STATEMENT: string;
	EVO_EDIT_BANK_STATEMENT: string;
	EVO_VALIDATE_BANK_STATEMENT: string;
	EVO_PROCESS_BANK_STATEMENT: string;
	EVO_MANAGE_BANK_STATEMENT_TEMPLATES: string;
	EVO_SAVE_BANK_STATEMENT_SETTINGS: string;
	EVO_VIEW_BANK_RECONCILIATION: string;
	EVO_MANAGE_BANK_RECONCILIATION: string;
	EVO_VIEW_CURRENCY: string;
	EVO_MANAGE_CURRENCY: string;
	EVO_VIEW_CURRENCY_HISTORY: string;
	EVO_MANAGE_CURRENCY_HISTORY: string;
	EVO_VIEW_PROJECT: string;
	EVO_MANAGE_PROJECT: string;
	EVO_VIEW_AREA: string;
	EVO_VIEW_BANK: string;
	EVO_VIEW_CUSTOMER_GROUP: string;
	EVO_VIEW_DISCOUNT_MATRIX: string;
	EVO_VIEW_PRICE_LIST: string;
	EVO_VIEW_SALES_REP: string;
	EVO_VIEW_SETTLEMENT_TERM: string;
	EVO_VIEW_SUPPLIER_GROUP: string;
	EVO_VIEW_TAX_TYPE: string;
	EVO_VIEW_TERM: string;
	EVO_VIEW_GL_TRANSACTION: string;
	EVO_VIEW_AR_TRANSACTION: string;
	EVO_VIEW_AP_TRANSACTION: string;
	EVO_VIEW_WH_TRANSFER: string;
	EVO_ENTRY_WH_TRANSFER: string;
	EVO_PROCESS_WH_TRANSFER: string;
	EVO_EDIT_WH_TRANSFER_DATE: string;
	EVO_MANAGE_WH_TRANSFER_TEMPLATE: string;
	EVO_VIEW_BRANCH_SETTINGS: string;
	EVO_MANAGE_BRANCH_SETTINGS: string;
	EVO_VIEW_INVOICE: string;
	EVO_MANAGE_INVOICE: string;
	EVO_MANAGE_INVOICE_EDIT_SETTINGS: string;
	EVO_VIEW_JOB_NUM: string;
	EVO_MANAGE_JOB_NUM: string;
	EVO_MANAGE_JOB_NUM_EDIT_SETTINGS: string;
	EVO_VIEW_MANUFACTURE: string;
	EVO_VIEW_UDF: string;
	EVO_MANAGE_UDF: string;
	EVO_VIEW_FCR_SETTINGS: string;
	EVO_MANAGE_FCR_SETTINGS: string;
	EVO_VIEW_FCR: string;
	EVO_POST_FCR: string;
	EVO_MANAGER_USER_MAPPING: string;

	EVO_JB_PROCESS_BATCH: string;
	EVO_VIEW_ITEM: string;
	EVO_MANAGE_ITEM: string;

	// UDF
	UDF_CREATE: string;
	UDF_EDIT: string;
	UDF_DELETE: string;

	// Evoflow workflow management
	EVO_MNG_WORKFLOW: string;
	EVO_MNG_STEPS: string;

	AUTHORIZATION_OVERVIEW: string;
	WA_MI_UDF: string;

	DMS_MANAGE_APPLICATION_SETTINGS: string;

	DMS_VIEW_LINK_OBJECTS_DOCUMENTS: string;
	DMS_UPLOAD_LINK_OBJECTS_DOCUMENTS: string;
	DMS_DELETE_LINK_OBJECTS_DOCUMENTS: string;
	DMS_VIEW_ALL_LINK_OBJECTS: string;
	DMS_MANAGE_LINK_OBJECTS: string;
	DMS_MANAGE_LINK_OBJECTS_USERS: string;

	AS_MNG_APP_SETTINGS: string;

	// Stock enquiry
	SE_VIEW_ALL_DB_STOCK: string;
	SE_FORCE_SYNC: string;
	SE_MANAGE_USER_DATABASE_LINK: string;
	SE_VIEW_USER_DATABASE_LINK: string;
	SE_MANAGE_DATABASE_LIST: string;
	SE_VIEW_DATABASE_LIST: string;
	SE_POST_SALES_ORDER: string;
	SE_POST_SALES_ORDER_FOR_CLIENT: string;
	SE_VIEW_SETTINGS: string;
	SE_MANAGE_SETTINGS: string;
	SE_VIEW_CHARACTERISTICS: string;
	SE_MANAGE_CHARACTERISTICS: string;
	SE_GET_PRICE_FOR_CLIENTS: string;

	// Stock enquiry OEM
	SE_OEM_ORDERS_MENU_ITEM_VISIBLE: string;
	SE_OEM_ORDERS_READ_ALL: string;
	SE_OEM_ORDERS_READ: string;
	SE_OEM_ORDERS_CREATE: string;
	SE_OEM_ORDERS_UPDATE: string;
	SE_OEM_ORDERS_DELETE: string;
	SE_OEM_ORDERS_APPROVE_ORDER: string;
	SE_OEM_ORDERS_CANCEL_ORDER: string;
	SE_OEM_ORDERS_SUBMIT_QUOTE: string;
	SE_OEM_ORDERS_MARK_DELIVERED: string;
	SE_OEM_ORDERS_SELECT_DEALER: string;
	SE_OEM_AUDIT_LOG_READ: string;
	SE_OEM_BRANCH_READ: string;
	SE_OEM_BRANCH_CREATE: string;
	SE_OEM_BRANCH_UPDATE: string;
	SE_OEM_BRANCH_DELETE: string;
	SE_OEM_DEALER_READ: string;
	SE_OEM_DEALER_CREATE: string;
	SE_OEM_DEALER_UPDATE: string;
	SE_OEM_DEALER_DELETE: string;
	SE_OEM_MANUFACTURER_READ: string;
	SE_OEM_DEALER_DC_LINK_READ: string;
	SE_OEM_DEALER_DC_LINK_CREATE: string;
	SE_OEM_DEALER_DC_LINK_UPDATE: string;
	SE_OEM_DEALER_DC_LINK_DELETE: string;
	SE_OEM_DISTRIBUTION_CENTER_READ: string;
	SE_OEM_CLIENT_READ: string;
	SE_OEM_MANAGEMENT_MENU_ITEM_VISIBLE: string;

	// Ticketing
	TICKET_GENERAL: string;
	TICKET_MANAGE_MENU_ITEM: string;

	TICKET_MANAGE_CHECKLISTS: string;
	TICKET_MANAGE_FORMS: string;
	TICKET_MANAGE_TICKET_TYPE: string;

	TICKET_CREATE_TICKETS: string;
	TICKET_VIEW_ALL_TICKETS: string;
	TICKET_EDIT_TICKETS: string;
	TICKET_ARCHIVE_TICKETS: string;
	TICKET_UPLOAD_DOCUMENTS: string;
	TICKET_REMOVE_DOCUMENTS: string;
	TICKET_COMMENTS_SEE_INTERNAL: string;
	TICKET_SET_PRIORITY: string;
	TICKET_ASSIGN_USER: string;

	// LMS
	LMS_LOAN_MENU_ITEM_VISIBLE: string;
	LMS_PARTY_MENU_ITEM_VISIBLE: string;
	LMS_PARTY_CATEGORY_MENU_ITEM_VISIBLE: string;
	LMS_LOAN_POOL_MENU_ITEM_VISIBLE: string;
	LMS_LOAN_STATUS_MENU_ITEM_VISIBLE: string;
	LMS_INTEREST_TYPE_MENU_ITEM_VISIBLE: string;
	LMS_TRANSACTION_TYPE_MENU_ITEM_VISIBLE: string;
	LMS_SUB_TRANSACTION_TYPE_MENU_ITEM_VISIBLE: string;
	LMS_CURRENCY_MENU_ITEM_VISIBLE: string;
	LMS_DEFAULTING_TEMPLATE_MENU_ITEM_VISIBLE: string;
	LMS_HOLIDAY_SCHEDULE_MENU_ITEM_VISIBLE: string;
	LMS_DISBURSEMENT_MENU_ITEM_VISIBLE: string;
	LMS_LOAN_PRODUCT_MENU_ITEM_VISIBLE: string;
	LMS_ASSET_BACKED_SECURITIES_MENU_ITEM_VISIBLE: string;
	LMS_DIRECT_DEBIT_MENU_ITEM_VISIBLE: string;
	LMS_REQUEST_FORMS_OVERVIEW_MENU_ITEM_VISIBLE: string;
	LMS_REQUEST_FORMS_TO_AUTHORIZE_MENU_ITEM_VISIBLE: string;
	LMS_VALIDATION_RULES_MENU_ITEM_VISIBLE: string;
	LMS_VALIDATION_JOBS_MENU_ITEM_VISIBLE: string;
	LMS_VALIDATION_HISTORY_MENU_ITEM_VISIBLE: string;
	LMS_SUBMIT_LOAN_MENU_ITEM_VISIBLE: string;
	LMS_SUBMIT_ASSET_MENU_ITEM_VISIBLE: string;
	LMS_SUBMISSION_CHECKLISTS_MENU_ITEM_VISIBLE: string;
	LMS_APPROVAL_PENDING_MENU_ITEM_VISIBLE: string;
	LMS_APPROVAL_TO_AUTHORIZE_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_DASHBOARD_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_APIS_DATAREADERS_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_DATASOURCES_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_REPORTS_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_NOTIFICATION_RUNS_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_NOTIFICATION_TEMPLATES_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_SETTINGS_MENU_ITEM_VISIBLE: string;
	LMS_REPORTING_FTP_SERVERS_MENU_ITEM_VISIBLE: string;
	LMS_TICKETS_MENU_ITEM_VISIBLE: string;
	LMS_TICKET_TYPES_MENU_ITEM_VISIBLE: string;
	LMS_TICKET_CHECKLISTS_MENU_ITEM_VISIBLE: string;
	LMS_TICKET_FORMS_MENU_ITEM_VISIBLE: string;
	LMS_GENERAL_SETTINGS_MENU_ITEM_VISIBLE: string;
	LMS_INTEGRATION_SETTINGS_MENU_ITEM_VISIBLE: string;
	LMS_IMPORT_TEMPLATES_MENU_ITEM_VISIBLE: string;
	LMS_USER_DEFINED_FIELDS_MENU_ITEM_VISIBLE: string;
	LMS_AUDIT_LOGS_MENU_ITEM_VISIBLE: string;
	LMS_WORKFLOWS_MENU_ITEM_VISIBLE: string;
	LMS_WORKFLOW_STEPS_MENU_ITEM_VISIBLE: string;
	LMS_USER_MANAGEMENT_MENU_ITEM_VISIBLE: string;
	LMS_GROUP_MANAGEMENT_MENU_ITEM_VISIBLE: string;
	LMS_APPLICATION_LOG_MENU_ITEM_VISIBLE: string;
	LMS_BANK_STATEMENTS_MENU_ITEM_VISIBLE: string;
	LMS_BANK_IMPORTS_MENU_ITEM_VISIBLE: string;
	LMS_BANK_ACCOUNTS_MENU_ITEM_VISIBLE: string;
	LMS_BANK_TEMPLATES_MENU_ITEM_VISIBLE: string;
	LMS_COLLATERAL_MENU_ITEM_VISIBLE: string;
	LMS_CONTACTS_MENU_ITEM_VISIBLE: string;

	LMS_DELETE_TRANSACTIONS: string;
	LMS_SUBMISSION_MENU_ITEM: string;
	LMS_SUBMIT_LOAN: string;
	LMS_SUBMIT_ASSET: string;
	LMS_SETTTINGS_MANAGEMENT: string;

	/** POD */
	POD_CONFIRM_QTY_SALESORDER: string;
	POD_ALLOW_START_MY_TRIPS: string;
	POD_MANAGE_TRIPS: string;
	POD_MANAGE_DRIVERS: string;
	POD_MANAGE_TRUCKS: string;
	POD_DELIVER_ALL_TRIPS: string;
	LMS_LOAN_READ: string;
	LMS_LOAN_CREATE: string;
	LMS_LOAN_UPDATE: string;
	LMS_LOAN_DELETE: string;
	LMS_LOAN_RESET: string;
	LMS_LOAN_OVERVIEW_EXPORT: string;
	LMS_LOAN_RECALC_BALANCES: string;
	LMS_LOAN_RECALC_LASTCALC: string;
	LMS_LOAN_CLONE: string;

	LMS_LOAN_STATUS_READ: string;
	LMS_LOAN_STATUS_CREATE: string;
	LMS_LOAN_STATUS_UPDATE: string;
	LMS_LOAN_STATUS_DELETE: string;
	LMS_LOAN_STATUS_OVERVIEW_EXPORT: string;

	LMS_LOAN_POOL_READ: string;
	LMS_LOAN_POOL_CREATE: string;
	LMS_LOAN_POOL_UPDATE: string;
	LMS_LOAN_POOL_DELETE: string;
	LMS_LOAN_POOL_OVERVIEW_EXPORT: string;

	LMS_PARTY_CATEGORY_READ: string;
	LMS_PARTY_CATEGORY_CREATE: string;
	LMS_PARTY_CATEGORY_UPDATE: string;
	LMS_PARTY_CATEGORY_DELETE: string;
	LMS_PARTY_CATEGORY_OVERVIEW_EXPORT: string;

	LMS_PARTY_READ: string;
	LMS_PARTY_CREATE: string;
	LMS_PARTY_UPDATE: string;
	LMS_PARTY_DELETE: string;
	LMS_PARTY_OVERVIEW_EXPORT: string;
	LMS_PARTY_USER_LINK_READ: string;
	LMS_PARTY_LINK_USERS: string;

	LMS_SUB_TRANSACTION_TYPE_READ: string;
	LMS_SUB_TRANSACTION_TYPE_CREATE: string;
	LMS_SUB_TRANSACTION_TYPE_UPDATE: string;
	LMS_SUB_TRANSACTION_TYPE_DELETE: string;
	LMS_SUB_TRANSACTION_TYPE_OVERVIEW_EXPORT: string;

	LMS_TRANSACTION_READ: string;
	LMS_TRANSACTION_CREATE_INTEREST_ADJUSTMENT: string;
	LMS_TRANSACTION_CREATE_ADDITION_REPAYMENT: string;
	LMS_TRANSACTION_UPDATE: string;
	LMS_TRANSACTION_DELETE: string;
	LMS_TRANSACTION_PREVIEW: string;
	LMS_TRANSACTION_POST_INTEREST_CALCULATION: string;
	LMS_FX_REVALUATION: string;

	LMS_TRANSACTION_TYPE_READ: string;
	LMS_TRANSACTION_TYPE_CREATE: string;
	LMS_TRANSACTION_TYPE_UPDATE: string;
	LMS_TRANSACTION_TYPE_DELETE: string;
	LMS_TRANSACTION_TYPE_OVERVIEW_EXPORT: string;

	LMS_CURRENCY_READ: string;
	LMS_CURRENCY_CREATE: string;
	LMS_CURRENCY_UPDATE: string;
	LMS_CURRENCY_DELETE: string;
	LMS_CURRENCY_OVERVIEW_EXPORT: string;

	LMS_CURRENCY_RATES_READ: string;
	LMS_CURRENCY_RATES_CREATE: string;
	LMS_CURRENCY_RATES_UPDATE: string;
	LMS_CURRENCY_RATES_DELETE: string;
	LMS_CURRENCY_RATES_OVERVIEW_EXPORT: string;

	LMS_HOME_SETTINGS_READ: string;
	LMS_HOME_SETTINGS_CREATE: string;
	LMS_HOME_SETTINGS_UPDATE: string;
	LMS_HOME_SETTINGS_DELETE: string;

	LMS_INTEREST_TYPE_READ: string;
	LMS_INTEREST_TYPE_CREATE: string;
	LMS_INTEREST_TYPE_UPDATE: string;
	LMS_INTEREST_TYPE_DELETE: string;
	LMS_INTEREST_TYPE_OVERVIEW_EXPORT: string;

	LMS_INTEREST_TYPE_RATE_READ: string;
	LMS_INTEREST_TYPE_RATE_CREATE: string;
	LMS_INTEREST_TYPE_RATE_UPDATE: string;
	LMS_INTEREST_TYPE_RATE_DELETE: string;
	LMS_INTEREST_TYPE_RATE_OVERVIEW_EXPORT: string;

	LMS_LOAN_INTEREST_TYPE_READ: string;
	LMS_LOAN_INTEREST_TYPE_CREATE: string;
	LMS_LOAN_INTEREST_TYPE_UPDATE: string;
	LMS_LOAN_INTEREST_TYPE_DELETE: string;

	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_READ: string;
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_CREATE: string;
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_UPDATE: string;
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_DELETE: string;
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_GENERATE: string;
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_RESET: string;

	LMS_COMPOUND_CALENDAR_READ: string;
	LMS_COMPOUND_CALENDAR_CREATE: string;
	LMS_COMPOUND_CALENDAR_UPDATE: string;
	LMS_COMPOUND_CALENDAR_DELETE: string;
	LMS_COMPOUND_CALENDAR_GENERATE: string;
	LMS_COMPOUND_CALENDAR_RESET: string;

	LMS_PAYMENT_DATE_CALENDAR_READ: string;
	LMS_PAYMENT_DATE_CALENDAR_CREATE: string;
	LMS_PAYMENT_DATE_CALENDAR_UPDATE: string;
	LMS_PAYMENT_DATE_CALENDAR_DELETE: string;
	LMS_PAYMENT_DATE_CALENDAR_GENERATE: string;
	LMS_PAYMENT_DATE_CALENDAR_RESET: string;

	LMS_CALCULATION_STEP_READ: string;
	LMS_CALCULATION_STEP_PREVIEW: string;
	LMS_CALCULATION_STEP_APPEND_PREVIEW: string;

	LMS_DAYCOUNT_CONVENTION_READ: string;

	LMS_CALCULATE_INTEREST: string;

	LMS_DEFAULTING_TEMPLATE_READ: string;
	LMS_DEFAULTING_TEMPLATE_CREATE: string;
	LMS_DEFAULTING_TEMPLATE_UPDATE: string;
	LMS_DEFAULTING_TEMPLATE_DELETE: string;

	LMS_VARIABLE_FIXED_AMOUNT_READ: string;
	LMS_VARIABLE_FIXED_AMOUNT_CREATE: string;
	LMS_VARIABLE_FIXED_AMOUNT_UPDATE: string;
	LMS_VARIABLE_FIXED_AMOUNT_DELETE: string;

	LMS_REPAY_VARIABLE_INTEREST_RATE_CREATE: string;
	LMS_REPAY_VARIABLE_INTEREST_RATE_READ: string;
	LMS_REPAY_VARIABLE_INTEREST_RATE_UPDATE: string;
	LMS_REPAY_VARIABLE_INTEREST_RATE_DELETE: string;
	LMS_REPAY_VARIABLE_INTEREST_RATE_GENERATE: string;
	LMS_REPAY_VARIABLE_INTEREST_RATE_RESET: string;

	LMS_LOAN_REPAYMENT_CONFIG_CREATE: string;
	LMS_LOAN_REPAYMENT_CONFIG_READ: string;
	LMS_LOAN_REPAYMENT_CONFIG_UPDATE: string;

	LMS_LOAN_REPAYMENT_HOLIDAY_CREATE: string;
	LMS_LOAN_REPAYMENT_HOLIDAY_READ: string;
	LMS_LOAN_REPAYMENT_HOLIDAY_UPDATE: string;
	LMS_LOAN_REPAYMENT_HOLIDAY_DELETE: string;

	LMS_POST_TO_INTEGRATION: string;
	LMS_INTEGRATION_CREATE_PARTY: string;
	LMS_INTEGRATION_SYNC: string;
	LMS_INTEGRATION_SETTINGS_READ: string;
	LMS_INTEGRATION_SETTINGS_UPDATE: string;

	LMS_AUDIT_LOG_READ: string;

	LMS_REFRESH_DATABASE: string;

	LMS_IMPORT_TEMPLATE_READ: string;
	LMS_IMPORT_TEMPLATE_CREATE: string;
	LMS_IMPORT_TEMPLATE_UPDATE: string;
	LMS_IMPORT_TEMPLATE_DELETE: string;

	LMS_BATCH_REQUEST_READ: string;
	LMS_BATCH_REQUEST_CREATE: string;
	LMS_BATCH_REQUEST_UPDATE: string;
	LMS_BATCH_REQUEST_DELETE: string;

	LMS_VALIDATION_READ: string;
	LMS_VALIDATION_CREATE: string;
	LMS_VALIDATION_UPDATE: string;
	LMS_VALIDATION_DELETE: string;
	LMS_VALIDATION_RUN: string;

	LMS_HOLIDAY_SCHEDULE_CREATE: string;
	LMS_HOLIDAY_SCHEDULE_READ: string;
	LMS_HOLIDAY_SCHEDULE_UPDATE: string;
	LMS_HOLIDAY_SCHEDULE_DELETE: string;

	LMS_HOLIDAY_SCHEDULE_DATE_CREATE: string;
	LMS_HOLIDAY_SCHEDULE_DATE_READ: string;
	LMS_HOLIDAY_SCHEDULE_DATE_UPDATE: string;
	LMS_HOLIDAY_SCHEDULE_DATE_DELETE: string;

	LMS_LOAN_PRODUCT_CREATE: string;
	LMS_LOAN_PRODUCT_READ: string;
	LMS_LOAN_PRODUCT_UPDATE: string;
	LMS_LOAN_PRODUCT_DELETE: string;
	LMS_LOAN_PRODUCT_BYPASS: string;

	LMS_UDF_READ: string;
	LMS_UDF_CREATE: string;
	LMS_UDF_EDIT: string;
	LMS_UDF_DELETE: string;

	RF_CREATE: string;
	RF_READ: string;
	RF_UPDATE: string;
	RF_DELETE: string;
	RF_SUBMIT_INTERN: string;
	RF_TO_AUTHORIZE: string;
	RF_SUBMISSION_READ: string;

	EVO_SCANNER_SETTTINGS_MANAGEMENT: string;

	LOCATION_CREATE: string;
	LOCATION_READ: string;
	LOCATION_UPDATE: string;
	LOCATION_DELETE: string;

	SCAN_CREATE: string;
	SCAN_READ: string;

	LMS_DIRECT_DEBIT_CREATE: string;
	LMS_DIRECT_DEBIT_READ: string;
	LMS_DIRECT_DEBIT_UPDATE: string;
	LMS_DIRECT_DEBIT_DELETE: string;

	SCAN_EMAIL_JOB_CREATE: string;
	SCAN_EMAIL_JOB_READ: string;
	SCAN_EMAIL_JOB_UPDATE: string;
	SCAN_EMAIL_JOB_DELETE: string;

	LMS_BANK_ACCOUNT_CREATE: string;
	LMS_BANK_ACCOUNT_READ: string;
	LMS_BANK_ACCOUNT_UPDATE: string;
	LMS_BANK_ACCOUNT_DELETE: string;

	LMS_BANK_TEMPLATE_CREATE: string;
	LMS_BANK_TEMPLATE_READ: string;
	LMS_BANK_TEMPLATE_UPDATE: string;
	LMS_BANK_TEMPLATE_DELETE: string;

	LMS_BANK_IMPORT: string;

	LMS_DISBURSEMENT_CREATE: string;
	LMS_DISBURSEMENT_READ: string;
	LMS_DISBURSEMENT_READ_DETAILS: string;
	LMS_DISBURSEMENT_UPDATE: string;
	LMS_DISBURSEMENT_DELETE: string;
	LMS_DISBURSEMENT_VIEW_WIDGET: string;
	LMS_DISBURSEMENT_PROCESS: string;
	LMS_DISBURSEMENT_CANCEL: string;

	LMS_COLLATERAL_READ: string;
	LMS_COLLATERAL_CREATE: string;
	LMS_COLLATERAL_UPDATE: string;
	LMS_COLLATERAL_DELETE: string;

	LMS_INFORMATIONAL_SCHEDULE_READ: string;
	LMS_INFORMATIONAL_SCHEDULE_GENERATE: string;

	LMS_OPERATIONAL_DASHBOARD_CARDS_READ: string;
	LMS_CLIENT_DASHBOARD_CARDS_READ: string;
	LMS_CLIENT_KPI_READ: string;
	LMS_SETTINGS_REFRESH: string;
	LMS_SETTINGS_RESET: string;
	LMS_DEFAULT_WF_CREATE: string;

	LMS_KYC_FORMS_READ: string;
	LMS_KYC_PROVIDER_READ: string;
	LMS_KYC_CHECK_READ: string;
	LMS_KYC_CHECK_UPDATE: string;
	LMS_KYC_CHECK_INITIATE: string;

	LMS_TRANSACTION_IMPORT_READ: string;

	LMS_PARTY_FS_CREATE: string;
	LMS_PARTY_FS_READ: string;
	LMS_PARTY_FS_UPDATE: string;
	LMS_PARTY_FS_DELETE: string;

	LMS_AUDIT_LOG_READ_ALL: string;

	// Batch imports
	BATCH_TEMPLATE_READ: string;
	BATCH_TEMPLATE_CREATE: string;
	BATCH_TEMPLATE_UPDATE: string;
	BATCH_TEMPLATE_DELETE: string;

	BATCH_REQUEST_READ: string;
	BATCH_REQUEST_CREATE: string;
	BATCH_REQUEST_UPDATE: string;
	BATCH_REQUEST_DELETE: string;

	// Syndicated loans
	LMS_SYNDICATES_CREATE_LENDER: string;
	LMS_SYNDICATES_ASSIGN: string;
	LMS_SYNDICATES_SEND_NOTIFICATION: string;

	// Contacts
	LMS_CONTACTS_READ: string;
	LMS_CONTACTS_CREATE: string;
	LMS_CONTACTS_UPDATE: string;
	LMS_CONTACTS_DELETE: string;
	LMS_CONTACTS_LINK: string;
}

export type PermissionKey = keyof Permissions;

export const Permissions: Permissions = {
	/**  Shows the dimensions management pages */
	MANAGE_DIMENSION: '4ce84f41-a762-4a03-ad2a-263a657247c5',
	/**  Allow the user to get all users. */
	USER_GET_ALL: '9c2e8905-8822-49c8-9f8e-e146b3deb298',
	/**  Allow the user to create a new user. */
	USER_CREATE: 'e6b5178c-d7be-42ab-976a-72dfe6b9bff4',
	/**  Allow the user to edit an existing user. */
	USER_EDIT: '4eb05512-07cd-4cfa-96aa-75783791c9df',
	/**  Allow the user to delete a user. */
	USER_DELETE: '687e5a4c-4438-471e-b3fc-ff1f7f4e0caf',
	/**  Allow the user to change his user settings. */
	USER_SETTINGS: '516d9838-c656-4d6d-8277-dc4c4b6b9934',
	/**  Allow the user to get all groups. */
	GROUP_GET_ALL: 'ea6e07b1-28dd-42a4-9a10-118024f6074b',
	/**  Allow the user to create a new group. */
	GROUP_CREATE: 'd932cdb7-397b-4875-ba9f-2560647e38f4',
	/**  Allow the user to edit an existing group. */
	GROUP_EDIT: '6c7298c9-8989-4bbc-98e1-705a112107ea',
	/**  Allow the user to delete a group. */
	GROUP_DELETE: 'bb71171f-24cb-4c98-92e9-658af78902d9',
	/** Allow the user to add and remove a user from one or multiple groups */
	USER_GROUP_UPDATE_USER: '9f09587e-403f-4734-8043-b0d2e21e2656',

	AP_VIEW_APPLICATION_LOGS: '81599b07-d8a0-47dc-ae94-bd60f46f81b5',

	/** Access reports */
	REPORTS_BI: '92aca970-c09b-49b5-9d44-717af9296fb7',
	/** Edit reports */
	REPORTS_BI_EDIT: '68c40b93-b0bb-4798-b4f8-617620b75d38',
	/** Show the reporting menu item */
	REPORTS_MENU_ITEM: '700313c2-1456-4a27-83c7-c4fbf2182493',
	/** Manage reporting datasources */
	REPORTS_DATASOURCES: 'da338e48-2eef-4215-a069-654a5a52f30f',
	/** Repository push (private) */
	REPORTS_PUSH: '68e524fe-17ab-4c92-a0bc-219c1121c231',
	/** Repository fetch */
	REPORTS_FETCH: '835dfa0d-f245-4421-acb1-707cf0da0487',
	/** Repository update */
	REPORTS_UPDATE: '31c06784-5847-4ee6-ac1e-b8a163977018',
	/** Update downstream */
	REPORTS_UPDATE_DOWNSTREAM: '45594d54-fd1d-40cf-ace8-5d9f47144594',
	/** Make public */
	REPORTS_MAKE_PUBLIC: '90b6bba6-34f5-428f-92c1-baf2d9296dd7',
	/** Manage organisation IDs */
	REPORTS_MNG_ORGANISATION_IDS: '5feeb1b8-6350-43ba-aab5-6422233dd280',
	/** Manage reporting settings */
	REPORTS_MNG_SETTINGS: '68f20fa4-f2e7-4e09-9ab3-f6287973c7d6',

	REPORTS_NOTIFICATION_TEMPLATES_READ: '65ba0b37-613d-4105-901e-08f57749e9a0',
	REPORTS_NOTIFICATION_TEMPLATES_CREATE: 'aa3b9f1d-6786-4abe-a237-e71dcc9ed7d7',
	REPORTS_NOTIFICATION_TEMPLATES_UPDATE: 'a1572ff1-0466-4e47-9398-e8db163be533',
	REPORTS_NOTIFICATION_TEMPLATES_DELETE: 'bfc024c6-3270-4402-a897-a0334e92335e',

	REPORTS_NOTIFICATION_RUNS_READ: '58b15803-17bd-43ad-acb9-f224d4628000',
	REPORTS_NOTIFICATION_RUNS_CREATE: '1698cec3-e5f1-47e6-aa93-edf00906a76c',
	REPORTS_NOTIFICATION_RUNS_UPDATE: '3755531e-3da3-4d6b-a52e-4efcab08c222',
	REPORTS_NOTIFICATION_RUNS_DELETE: '9ee9b934-522b-48cc-9017-b06dc2826150',

	REPORTS_NOTIFICATION_NOTIFICATION_READ: '2d6e8903-a4f3-4908-8442-62fe690eed0b',
	REPORTS_NOTIFICATION_NOTIFICATION_UPDATE: 'bed53250-fdaa-492d-94d9-4fd1c45e1ca8',
	REPORTS_NOTIFICATION_NOTIFICATION_DELETE: 'ab9ff0f4-ffb4-438a-95ec-02fd33fa4621',
	REPORTS_NOTIFICATION_NOTIFICATION_IGNORE: '8cc6d8eb-dd34-49d6-b152-2210192bc198',

	/** Access the dashboard of EPO */
	DASHBOARD_ACCESS: 'ceb3a968-2989-44a1-a0d6-204832493ea8',
	/** Access the authorization page of EPO to authorize purchase orders */
	AUTHORIZATIONS_ACCESS: 'cc40ba6e-6e99-44af-8e59-364191d9ff00',
	/** Access the authorization requisition page */
	REQUISITION_AUTH_ACCESS: '01b4b26e-93a8-4f9b-8cb6-50c70a131349',
	/** Set the user as admin of the system */
	EPO_SYSTEM_ADMIN: 'f6630f7b-c752-4ae3-9996-f46a0a6652c1',
	/** Access the draft page */
	DRAFTS_ACCESS: '5be051ff-2f2d-4a3b-80c6-6e87d28fb165',
	/** Access the purchase order page */
	PURCHASE_ORDER_ACCESS: '04cf45ca-fd72-405c-9aa7-26d8b8dd41e8',
	/** Access the debit batch page */
	DEBIT_BATCH_ACCESS: '9b7cf4ed-1c6f-40e7-92bf-470d3dbbfd22',
	/** Access the debit batch authorization page */
	DEBIT_BATCH_AUTHORIZATIONS_ACCESS: '12e229a9-3a97-4f4f-b180-f990e44a40c0',
	/** Access the requisition page */
	REQUISITION_ACCESS: 'af17ff74-de3f-4a71-a9b2-92c02ff9a7b2',
	/** Access the overview of Procurements */
	ADVANCED_PROCUREMENT_ACCESS: '619064ad-0342-4823-aaf6-f9c194e351a7',
	/** Access the overview page of orders such as purchase order */
	OVERVIEWS_ACCESS: 'ae96bdac-92fa-4f9a-ab1b-dcafb6a73409',
	/** Access the delegation page */
	DELEGATES_ACCESS: '2da59c11-c705-42e1-b50e-d9eca686f187',
	/** Access the workflow manager mage */
	WORKFLOWS_ACCESS: '11459333-b4eb-4926-95ec-4f2a1a817c3a',
	/** Access the delegation manager page */
	DELEGATION_MANAGER_ACCESS: '986252ef-1bff-4f3d-9a53-e859c7f38b82',
	/** Access the report page */
	REPORTS_ACCESS: '1d7fdc5e-24b7-48ec-8a3d-b057813f4640',
	DATASOURCES: 'cf756dfc-fac0-45b7-ad22-c37538b9d6c2',
	DATASOURCES_EDIT: 'fcb0dfb8-dd43-4492-962b-e1ce6b8b3b85',
	DATASOURCES_CREATE: 'd98548b1-7e94-4e67-80ba-aa630149f21c',

	LICENSE_ACCESS: '6faae993-690f-4512-90a6-4c4601bf98b6',
	AS_UM_MI_USER_MANAGEMENT_MENU_ITEM: 'd3144973-5251-4f86-bee4-0ef4e590fcae',
	AS_UM_MI_USERS: '497164c7-4b08-4735-8f45-631466c1c855',
	AS_UM_MI_GROUPS: 'c5ce096a-4c53-46ab-b01c-0ae87e08d699',
	AS_UM_MI_SESSION_MANAGEMENT_MENU_ITEM: 'bf0a4417-5d1d-49ce-96a1-93f1ad34f7ba',
	AS_UM_MI_SESSION_MANAGEMENT_SETTINGS: 'cff79bf3-27c2-494a-aa6c-c7069555db4b',
	AS_UM_MI_SESSION_MANAGEMENT: 'fd08ba0a-33e5-45fb-8ede-5a7c7c79fb44',
	MANAGEMENT_PORTAL_ACCESS: '271ea9e4-a35f-4c7b-98eb-9338bdc280dd',

	// Menu items
	AP_MANAGE_MENU_ITEM: '0664e86f-532b-4270-8ad1-7ee28f144152',
	TIP_MI_DMS_OVERVIEW: 'cfcd16ac-7e82-490d-83d9-bf2876c253d5',

	// Ftp module
	FTP_MENU_ITEM: 'fec7fb00-9913-47a5-8c81-ce96cc5221e8',
	FTP_SERVER_READ: 'e84192da-cf13-4ce1-8648-c1fecb292ded',
	FTP_SERVER_TEST_CONNECTION: '4960b720-ab71-4227-8ae9-80de1abd2ec9',
	FTP_SERVER_CREATE: 'a31ccc2d-a462-4677-9cf3-a2a3293459e5',
	FTP_SERVER_DELETE: '7105e72f-10a7-402f-b998-26becafb5bc8',
	FTP_SERVER_UPDATE: '2761af29-1e43-4f66-a979-e0799cec6215',

	// Connected apps
	AP_MANAGE_APPS: 'e7a7e3ec-b0b0-45f9-bb99-9dc435e8b762',
	AP_MANAGE_APP_USERS: 'ee3944ef-19ae-4509-83df-82701d8eb1b8',
	AP_CREATE_APPS: 'de02a495-f2df-4aae-bd93-3b86a2ac4584',
	AP_ACCESS_ALL_COMPANY_APPS: '82d0104f-ba6f-487b-b989-d16a4474f283',
	AP_MANAGE_ALL_COMPANY_APPS: '5590e0d9-4c6a-419e-8e2f-ce34d919620a',

	// Companies
	AP_MANAGE_COMPANIES: 'e951e3fd-e911-4da6-b77e-dbfa60bcc93a',
	AP_MANAGE_COMPANY_USERS: 'c2b66fe0-6676-40a3-8ae2-71ae91469452',
	AP_CREATE_COMPANIES: 'b04e1e38-2219-4286-b6cc-fd7093f42add',
	AP_ACCESS_ALL_ORGANISATION_COMPANIES: 'ccc24de8-b71f-456e-ad92-0fb5db1970bf',
	AP_MANAGE_ALL_ORGANISATION_COMPANIES: '3c7a1dfd-7d2f-456e-b171-66c55b31eaf8',

	AP_ADD_ALL_ORGANISATION_USERS: '934c3c8a-aa78-43b7-b93d-585b72f9aee0',

	// Organisations
	AP_MANAGE_ORGANISATIONS: '7c4a13b7-b907-45ce-8e32-e0649a7e88b4',
	AP_INVITE_ORGANISATION_USERS: '78d1fe3e-921d-405a-bed4-8f0dc2e4366b',
	AP_MANAGE_ORGANISATION_USERS: '5b806479-1555-4271-a39d-ba44a33c2cfe',
	AP_CREATE_ORGANISATIONS: '58480c6b-a04b-4925-a0b1-1c501b5bb21a',

	// Quick Setup
	AP_CREATE_SETUP: '702145CC-F4CB-4FCD-A6BB-A67D3AEAD64F',

	// Database management
	AP_CREATE_DATABASE: 'ae2a7ceb-3428-4dc4-9651-00d6217e02c7',
	AP_COPY_DATABASE: '544649f9-9640-4dd3-bc95-46d0af0a294f',

	// Application types
	AP_MANAGE_APPLICATION_TYPES: 'd9b95333-2967-40a0-8914-b89f6f0cadb1',

	// Audit logs
	AP_VIEW_AUDIT_LOGS: '2ccfed12-8d01-449e-89b2-2850d4cde6b6',

	// Incident logs
	AP_VIEW_INCIDENT_LOGS: '5e7c7653-6d4c-4e2b-b8f6-7365121aac7e',
	// Incident logs
	AP_FETCH_API_STATUSSES: 'fad8f69c-de50-4369-a19b-031f4146d1e6',

	// Manage portal settings
	AP_MANAGE_PORTAL_SETTINGS: '5d0168b8-f103-4bb3-8f6c-ea892a63dfc3',

	// User management
	AP_APPROVE_REJECT_USERS: 'daf5f2ae-ba5a-4988-b7bd-74932d0bce39',
	AP_USER_APPROVAL_ORGANISATION: '71dab7a9-f711-4b92-8e8d-86ab9fbfc16b',
	AP_USER_APPROVAL: 'bcbaa049-f47d-4595-9514-78261df39693',

	// TIP-DMS
	TIP_DMS_DELETE: 'a414682d-4c1e-4d2c-9c42-bfb1c131c2ce',
	TIP_DMS_EDIT: '085d1c0c-0107-4b17-a3c6-79dfc62c7b78',

	TIP_MANAGE_DOCUMENT_CATEGORIES: '6b9cd25a-ebe2-4677-a6b0-4beb42587622',

	TIP_VIEW_ALL_INVESTOR: '2b9d5c8c-b2cc-4670-8bf5-a4854d8c16d1',
	TIP_VIEW_COMPANY_INVESTOR: 'ad9764dd-0bad-47f2-a039-e95f401691ed',
	TIP_CREATE_COMPANY_INVESTOR: '3e3224e7-dc1f-4405-8bcc-1855306fa4d9',
	TIP_EDIT_COMPANY_INVESTOR: '12b45f93-03da-4a10-bf35-e1818da5328c',
	TIP_DELETE_COMPANY_INVESTOR: '67bc5d5a-0614-4bee-bd14-f9a37386da4b',
	TIP_MANAGE_INVESTOR_USER: '7629d261-a3f5-419e-8dc9-d53e3a215b7a',

	// AP-DMS2
	DMS_UPLOAD_DOCUMENT: 'ffb927e0-665e-46e9-acfe-1614ae7b5d81',
	DMS_DELETE_DOCUMENT: 'a8f48540-a11e-4077-be27-ae9d391f678e',
	DMS_EDIT_DOCUMENT: '0b5df2c6-5aed-4e13-9c81-388780b01428',
	DMS_DOWNLOAD_DOCUMENT: '7f0655c7-bdf4-448f-9e2f-779a6900eb7b',

	DMS_MANAGE_RECORD_TYPES: '2b2ea7fa-ff1a-4560-890a-dda0e663c84b',
	DMS_MANAGE_CATEGORIES: '49f68118-94d7-457c-b6cb-0eec9acb9c53',
	DMS_MANAGE_BASKETS: 'f0dac650-da4e-442c-9f57-a8ab0751e3ea',
	DMS_MANAGE_BASKET_DOWNLOADS: '938435a5-0473-4e2a-8ac0-d700930bf1dd',

	// Loan creation
	LC_MANAGE_CHECKLISTS: 'bf8e7f05-3bea-4137-a068-0856268d43ed',
	LC_SUBMIT_LOANS: '1b6fd1e1-9e18-4f9e-bd8f-60e43ede90ba',
	LC_EDIT_ON_APPROVAL: '0f7e4e05-0414-43a7-b25d-3614c2b19cb2',

	//Transaction import
	TI_CANCEL_IMPORT: '7970bb43-5817-4a94-94f6-5b5d556bf95b',
	TI_CREATE_IMPORT: '486033c6-9635-4c9d-8733-a49dcad1b3b4',
	TI_APPROVE_IMPORT: 'a9be8a68-a8af-4bc9-83c5-1b8a78213f58',
	TI_PROCESS_IMPORT: '8e244703-ba4c-4853-9b76-14925d376156',
	TI_RETRIEVE_IMPORT: 'b2d9f2df-ab31-4b7f-a77e-3125e945fded',
	TI_VALIDATE_IMPORT: '2f8a58d3-c553-4a1d-972a-0e9676af38d4',

	EVO_VIEW_CUSTOMER: '4e980fbf-3e36-4c96-8824-cf16f4964bd1',
	EVO_MANAGE_CUSTOMER: 'a527ae1b-5f30-4977-bf11-7930e8618a3a',
	EVO_VIEW_SUPPLIER: '4be2213b-75d9-466e-87fd-f64c0150e873',
	EVO_MANAGE_SUPPLIER: '33fd35f2-bdc2-4256-94ee-b307fc124cbd',
	EVO_VIEW_GL_ACCOUNT: 'a4bff268-068b-493f-9a72-e7a06448039b',
	EVO_MANAGE_GL_ACCOUNT: 'ee1861d3-2a0a-458a-8cc4-9936e1dfd31d',
	EVO_VIEW_CASHBOOK_BATCH: '4f262740-dd0f-43a8-82f2-f136c952d910',
	EVO_SAVE_CASHBOOK_BATCH: 'f35c75c9-9b4d-43af-bacd-e27af04f4d45',
	EVO_VALIDATE_CASHBOOK_BATCH: '8f563af6-f22b-43d6-a661-431c03eeee69',
	EVO_PROCESS_CASHBOOK_BATCH: 'abfa8561-0d48-4f61-8d73-f470b406bc06',
	EVO_VIEW_BANK_STATEMENT: 'c45f0b84-3abd-44aa-be66-11b7caecd1ea',
	EVO_IMPORT_BANK_STATEMENT: 'c735858d-d64f-4ef7-a455-038dd9fda7aa',
	EVO_EDIT_BANK_STATEMENT: '6a6f9eaa-27fe-44f1-8207-838cc148e560',
	EVO_VALIDATE_BANK_STATEMENT: 'c2d3eb81-eebb-41fa-ba60-bc08a9632067',
	EVO_PROCESS_BANK_STATEMENT: '5b17612c-11db-4876-9375-bd48d1152ceb',
	EVO_MANAGE_BANK_STATEMENT_TEMPLATES: 'f7cab743-f109-4098-9b86-cdd153c15cc7',
	EVO_SAVE_BANK_STATEMENT_SETTINGS: '1a4ed22e-e6df-41a7-a4a5-56fea0e4573e',
	EVO_VIEW_BANK_RECONCILIATION: '"8982C28C-F1E4-44E6-8954-17EF692C4757"',
	EVO_MANAGE_BANK_RECONCILIATION: 'CA499FA1-2B5D-4C36-8FEC-0BB22A51099E',
	EVO_VIEW_CURRENCY: '0d76e459-ca42-4600-8f7a-609b19c5e8ae',
	EVO_MANAGE_CURRENCY: '38505e15-5f4a-4006-9bd6-88e78d582777',
	EVO_VIEW_CURRENCY_HISTORY: '8aa8afc5-087c-4f5b-851a-8b9251092963',
	EVO_MANAGE_CURRENCY_HISTORY: '774581c6-210e-48cb-b96f-4f15789f2c54',
	EVO_VIEW_PROJECT: '65f329f5-ab0d-4254-9bbd-10f1cc3d42f0',
	EVO_MANAGE_PROJECT: 'f7129ada-d2b6-4e72-a7b7-1702252ec992',
	EVO_VIEW_AREA: '4972621c-8db0-4cc5-b420-d7bd65807ad4',
	EVO_VIEW_BANK: '5a3fe29b-2cc3-46ba-8698-8c075bf85f50',
	EVO_VIEW_CUSTOMER_GROUP: '8e901ab5-ef5f-4a03-a066-3927105d28d2',
	EVO_VIEW_DISCOUNT_MATRIX: '92932764-dbfe-431d-ae9f-3fc78e8be282',
	EVO_VIEW_PRICE_LIST: '84b82ce1-2a81-4391-98e7-75b9efa06652',
	EVO_VIEW_SALES_REP: 'b0c89af7-08b9-4a0d-bad8-ac513f4d78e6',
	EVO_VIEW_SETTLEMENT_TERM: '4217711c-e898-4c4a-b25c-4aac950445f1',
	EVO_VIEW_SUPPLIER_GROUP: 'b882b255-d395-4275-be58-2a3fa5432c79',
	EVO_VIEW_TAX_TYPE: '1d289895-764c-49ba-a2dd-25136cf78b10',
	EVO_VIEW_TERM: '75bfa258-266e-424f-bba5-b97082a4981e',
	EVO_VIEW_GL_TRANSACTION: 'ae7c6eaa-3e32-49ee-9ba3-deb99edc7147',
	EVO_VIEW_AR_TRANSACTION: 'a1ae8840-d4b8-4ee2-b1c1-08282f74810b',
	EVO_VIEW_AP_TRANSACTION: '555e91fa-5f53-43a7-bb64-ad29d20eed68',
	EVO_VIEW_WH_TRANSFER: '0f7faf1e-befc-45fa-a998-185dc4ad6c50',
	EVO_ENTRY_WH_TRANSFER: 'e7963666-4b26-4a09-b6af-132745b7ce5d',
	EVO_PROCESS_WH_TRANSFER: '319b73e7-ad05-4a11-8aa0-d0585a6db553',
	EVO_EDIT_WH_TRANSFER_DATE: 'd7ee0504-a150-4721-848e-b035c986e3c4',
	EVO_MANAGE_WH_TRANSFER_TEMPLATE: '6c44e806-40b1-4638-b521-fc0d22b40755',
	EVO_VIEW_BRANCH_SETTINGS: 'af00ea44-3c56-4693-8627-304866f65728',
	EVO_MANAGE_BRANCH_SETTINGS: '78f37028-0417-487d-bd8c-3e5c5924f0f2',
	EVO_VIEW_INVOICE: '92fa8298-a036-48d1-a165-e7cb0d74bd5a',
	EVO_MANAGE_INVOICE: 'a24a5115-313f-4e57-9083-7ca2c321e56b',
	EVO_MANAGE_INVOICE_EDIT_SETTINGS: 'c35cce18-c615-4e20-b109-12e482325369',
	EVO_VIEW_JOB_NUM: 'c5805ea6-bbff-41c3-a674-c25223ba005b',
	EVO_MANAGE_JOB_NUM: '427b0a06-1d3f-40ee-9238-7fc9b2766290',
	EVO_MANAGE_JOB_NUM_EDIT_SETTINGS: 'b5eec146-78f2-4994-8ffe-482aa06d173e',
	EVO_VIEW_MANUFACTURE: '1610D60C-8F5B-4BDD-8337-2B658DA63C04',
	UDF_CREATE: '638ca06c-3f57-4285-a779-a98c21f1843c',
	UDF_EDIT: '98631c34-3de5-42c3-b2ae-4e53c90a093a',
	UDF_DELETE: '21cc7f7e-e392-45a5-9f93-79029797dfdc',
	EVO_MNG_WORKFLOW: '7c122240-ab0f-4ebd-8b8b-12af2253f411',
	EVO_MNG_STEPS: '5cce05ab-17f2-49ee-8227-2ba1e5a17ba3',
	WA_MI_UDF: '33be1447-2c2d-4642-bf39-420dadaedeb8',
	AUTHORIZATION_OVERVIEW: '0bd1a578-da65-47d2-8f21-f2182078396f',
	EVO_VIEW_UDF: '88E2804F-0D1E-44EF-8840-36A531FF609D',
	EVO_MANAGE_UDF: '95FC6A82-EBE5-4D00-A171-C201B0F05AD5',
	EVO_VIEW_FCR_SETTINGS: '3615D4BB-0EC4-4154-93CA-0C8A7C810527',
	EVO_MANAGE_FCR_SETTINGS: 'F82DC323-C02B-407E-862A-73DF6CF2DA89',
	EVO_VIEW_FCR: '72F92DA9-90DF-4B96-ADCE-2339C999A2C9',
	EVO_POST_FCR: '0AD1DB3D-7629-4363-A8F4-65FB96EE15C2',
	EVO_MANAGER_USER_MAPPING: 'b45b4400-0dcf-4a20-94ae-6f3d00461ba8',

	EVO_JB_PROCESS_BATCH: '45240044-4546-4955-AB7E-103D10FC62FB',
	EVO_VIEW_ITEM: '4447587E-C858-4F19-BC3B-DA5B08487A2C',
	EVO_MANAGE_ITEM: '40F8CD8B-59DF-40AB-8EB7-A4CE872EFFB5',

	DMS_MANAGE_APPLICATION_SETTINGS: '44897ecb-35c8-4ae8-b04f-ac8f2a0b8efa',

	DMS_VIEW_LINK_OBJECTS_DOCUMENTS: '70efdc82-feed-4cda-9b7f-41b496435376',
	DMS_UPLOAD_LINK_OBJECTS_DOCUMENTS: '2153d566-5666-4ddf-bc56-e0efbc9bc147',
	DMS_DELETE_LINK_OBJECTS_DOCUMENTS: '808d64dd-72d9-40ef-b9a8-420ebab7404a',
	DMS_VIEW_ALL_LINK_OBJECTS: 'b52f34b9-2c9b-4254-be66-0567ee52bc96',
	DMS_MANAGE_LINK_OBJECTS: 'ad5efd48-b5d0-407f-82bb-794edf1d64a0',
	DMS_MANAGE_LINK_OBJECTS_USERS: '1ec6aaf7-28fe-418a-9fad-515489e8eb60',

	AS_MNG_APP_SETTINGS: '350a0a42-3231-44dd-ae69-e7d16ca02fe2',

	// Stock enquiry
	SE_VIEW_ALL_DB_STOCK: '3d844acc-2bb3-43e3-b71f-f8d3f79869a7',
	SE_FORCE_SYNC: 'a9b0ac46-a5a1-4482-a0d0-1166f7998107',
	SE_MANAGE_USER_DATABASE_LINK: '3af9bb09-fe6d-41e4-94fc-a6c213d600f7',
	SE_VIEW_USER_DATABASE_LINK: '7df21a48-6420-4fa4-8482-45dddadda829',
	SE_MANAGE_DATABASE_LIST: '1c2bd9d0-3d64-4902-933e-6bd0ca288f6d',
	SE_VIEW_DATABASE_LIST: 'a454f49b-f4b5-45c9-b8c3-92bf5561a659',
	SE_POST_SALES_ORDER: '69f91f87-14a0-497e-8e57-8b1f1d8f5828',
	SE_POST_SALES_ORDER_FOR_CLIENT: 'F185D4FE-A394-4B70-B088-76568C886653',
	SE_VIEW_SETTINGS: 'f9388318-4622-4f36-88d7-6dcb129e47e0',
	SE_MANAGE_SETTINGS: 'd7e931d5-8390-489f-9140-cfbf7217b634',
	SE_VIEW_CHARACTERISTICS: 'b76a6014-4256-44e0-8744-f9d60191d707',
	SE_MANAGE_CHARACTERISTICS: '98832af5-1324-408d-9e18-127245dc6568',
	SE_GET_PRICE_FOR_CLIENTS: 'BFD8509A-8432-4F94-BD84-335A882CA3D8',

	// Stock enquiry OEM
	SE_OEM_ORDERS_MENU_ITEM_VISIBLE: 'E63B0242-03D1-46FE-943E-FBB92FF54259',
	SE_OEM_ORDERS_READ: '8C0744D4-B2FE-4178-BD31-B84CE88D7073',
	SE_OEM_ORDERS_READ_ALL: '1D30B07A-3D31-4A15-8E51-F4C400EF71CE',
	SE_OEM_ORDERS_CREATE: '18FE6132-50CF-4F32-96E1-30A54FDD6320',
	SE_OEM_ORDERS_UPDATE: '4CA16C12-96FE-43D7-A53F-54FE23EC5D2B',
	SE_OEM_ORDERS_DELETE: 'C0311D0E-6EC5-4C62-8860-DD43CCB7557E',
	SE_OEM_ORDERS_APPROVE_ORDER: '64276C3C-3569-4BEF-B677-2A6E71C0D514',
	SE_OEM_ORDERS_CANCEL_ORDER: 'BE7415B8-FE4F-4758-8A90-CC51D24DC193',
	SE_OEM_ORDERS_SUBMIT_QUOTE: 'A3CA1020-12A9-4256-B528-45FC3914D511',
	SE_OEM_ORDERS_MARK_DELIVERED: 'E801F793-2B3F-48F9-9921-6D5CC66EBDFE',
	SE_OEM_ORDERS_SELECT_DEALER: 'D305AC5F-F9AB-41A3-9651-1D2983E15964',
	SE_OEM_AUDIT_LOG_READ: 'F775AC50-4DD7-4973-9FDB-7E7C2EEBF7C3',
	SE_OEM_BRANCH_READ: '38F08739-7BEB-4508-906E-E0B1B27D6432',
	SE_OEM_BRANCH_CREATE: 'B972116B-5CEB-43BB-AEEE-E0AD46F00FC0',
	SE_OEM_BRANCH_UPDATE: '820F9E84-716B-4D51-B525-7B9F795DC7FF',
	SE_OEM_BRANCH_DELETE: '20B0C324-4EB6-4232-B317-020CEC31E726',
	SE_OEM_DEALER_READ: 'CCD1AECA-763F-4719-B1E1-5E659158A082',
	SE_OEM_DEALER_CREATE: '98833D7B-16B1-4BE7-942C-6F075793D71A',
	SE_OEM_DEALER_UPDATE: '6BAB85B7-2329-40F6-87FE-3DCB1BE77813',
	SE_OEM_DEALER_DELETE: '87009E09-D810-435C-AE36-D09CB1646208',
	SE_OEM_MANUFACTURER_READ: 'A27AAA78-2FE9-4250-86C9-54D320212D53',
	SE_OEM_DEALER_DC_LINK_READ: 'B4530D69-5183-43B1-A012-42676886AE67',
	SE_OEM_DEALER_DC_LINK_CREATE: '568378E5-FDFF-4DA7-B8FC-2ED14FF0EFC7',
	SE_OEM_DEALER_DC_LINK_UPDATE: '7DC7F8EF-0DA5-4688-AC42-34F88A04F3D7',
	SE_OEM_DEALER_DC_LINK_DELETE: 'E52D1A5A-420B-4638-AFF2-1ABBCAB894C6',
	SE_OEM_DISTRIBUTION_CENTER_READ: '681FD55F-E27A-4296-9287-90A014305D24',
	SE_OEM_CLIENT_READ: '9C2809BA-13CD-4195-B2B5-553ACEF9A535',
	SE_OEM_MANAGEMENT_MENU_ITEM_VISIBLE: '43EC6EAF-3CFB-4536-A685-229968DFE62D',

	TICKET_GENERAL: '433ee62c-ce38-4a62-8bad-66ac6fd75757',
	TICKET_MANAGE_MENU_ITEM: '458799af-80c6-4922-90ab-285aeb4fa979',

	TICKET_MANAGE_CHECKLISTS: '6cce77c4-0fa2-44fd-8000-c2a7cc0e8b0d',
	TICKET_MANAGE_FORMS: 'f8a24559-167d-47cf-9028-65876d8975b6',
	TICKET_MANAGE_TICKET_TYPE: '86b3105f-6d5b-461a-9217-bfd40c9a6970',

	TICKET_CREATE_TICKETS: '5d0d0aa9-536c-4c96-ac51-46762f2d6e42',
	TICKET_VIEW_ALL_TICKETS: '651bad2f-1adc-4ba8-b92c-e8ac7d2afe2b',
	TICKET_EDIT_TICKETS: '59d74c26-f96a-4cdf-a709-5062050f75de',
	TICKET_ARCHIVE_TICKETS: '766ac013-ec3d-49cb-be66-438744db7b83',
	TICKET_UPLOAD_DOCUMENTS: '06c8df9b-8739-4694-8bad-6cbee9df08ca',
	TICKET_REMOVE_DOCUMENTS: 'f162dad2-d030-4b2f-90f0-e1fe71ceb514',

	TICKET_COMMENTS_SEE_INTERNAL: 'e386c5e2-be81-4d79-9743-22216dbe6f95',
	TICKET_SET_PRIORITY: 'c21edb00-ae04-46fe-bb1f-6513dc13d45a',
	TICKET_ASSIGN_USER: '7eb34704-4d5b-4d0c-abf9-2a95fc6e8b5d',

	// LMS
	LMS_LOAN_MENU_ITEM_VISIBLE: '1F806E7B-D31B-4711-BAE7-C1E3A5833D00',
	LMS_PARTY_MENU_ITEM_VISIBLE: 'F65C65A9-D0FD-48E5-802B-DABCDE9BBCAC',
	LMS_PARTY_CATEGORY_MENU_ITEM_VISIBLE: 'D0EB560C-82EF-43F8-99DF-E0836516E68D',
	LMS_LOAN_POOL_MENU_ITEM_VISIBLE: 'F8D99E8D-9B3C-4A5E-B11C-58B1D1010196',
	LMS_LOAN_STATUS_MENU_ITEM_VISIBLE: '8B4D099A-E1BD-4427-80A8-5250515B6A64',
	LMS_INTEREST_TYPE_MENU_ITEM_VISIBLE: 'BFE8F1C0-4F26-40B6-8AA4-6CEA67829291',
	LMS_TRANSACTION_TYPE_MENU_ITEM_VISIBLE: '2D8F3F1D-518C-4C3C-B427-C2A0D9B0C820',
	LMS_SUB_TRANSACTION_TYPE_MENU_ITEM_VISIBLE: '4117419D-2700-416D-885D-1C36B49BD4B0',
	LMS_CURRENCY_MENU_ITEM_VISIBLE: 'CC80EB8C-691F-410E-94C4-36DF18AFA5A2',
	LMS_DEFAULTING_TEMPLATE_MENU_ITEM_VISIBLE: 'DDD55FFE-60A3-4F07-BEC0-658F7477BED8',
	LMS_HOLIDAY_SCHEDULE_MENU_ITEM_VISIBLE: '32E3606F-FA3A-48CF-BF68-D7C5AB12B4E5',
	LMS_DISBURSEMENT_MENU_ITEM_VISIBLE: 'E2E44A1B-7BF5-4150-BBA0-62BCEFC885C8',
	LMS_LOAN_PRODUCT_MENU_ITEM_VISIBLE: '34C6EB15-3226-40BC-A4A8-9F7BBD1E24C9',
	LMS_ASSET_BACKED_SECURITIES_MENU_ITEM_VISIBLE: 'CBF0F5EB-50DB-4846-93EC-CF1841FE21B6',
	LMS_DIRECT_DEBIT_MENU_ITEM_VISIBLE: '0912E4F3-B1CD-4EB1-A297-83160DC9704C',
	LMS_REQUEST_FORMS_OVERVIEW_MENU_ITEM_VISIBLE: '56D164C2-EEE5-4FF4-A0B5-079E2AF6E03B',
	LMS_REQUEST_FORMS_TO_AUTHORIZE_MENU_ITEM_VISIBLE: '60ABAE17-DD1A-435F-A295-5D639B427B82',
	LMS_VALIDATION_RULES_MENU_ITEM_VISIBLE: 'E75572F9-FFE3-48A1-BF04-AFBD254D5F53',
	LMS_VALIDATION_JOBS_MENU_ITEM_VISIBLE: '9CB10721-353C-456F-9783-3F35A801B0D0',
	LMS_VALIDATION_HISTORY_MENU_ITEM_VISIBLE: '9E9F37F8-B163-4F7C-ACA4-637F51DEA39A',
	LMS_SUBMIT_LOAN_MENU_ITEM_VISIBLE: '18F003E4-FABC-4BAE-8CB0-8CB6487B5C80',
	LMS_SUBMIT_ASSET_MENU_ITEM_VISIBLE: '76C2E436-9BC0-4F30-9395-D15070105A26',
	LMS_SUBMISSION_CHECKLISTS_MENU_ITEM_VISIBLE: 'F5497559-F0A7-4396-9464-B2BA6259331C',
	LMS_APPROVAL_PENDING_MENU_ITEM_VISIBLE: '915D1727-0BD5-494F-A931-08EF91698B30',
	LMS_APPROVAL_TO_AUTHORIZE_MENU_ITEM_VISIBLE: '88F7FB02-1F73-47A4-8513-85E8897390F0',
	LMS_REPORTING_DASHBOARD_MENU_ITEM_VISIBLE: 'D9BDB86A-DA35-4EE4-A1F4-A747CF8732F1',
	LMS_REPORTING_APIS_DATAREADERS_MENU_ITEM_VISIBLE: '843F8C73-1146-4FF2-AEDC-E12A07704E8D',
	LMS_REPORTING_DATASOURCES_MENU_ITEM_VISIBLE: '50A19B15-B16E-44D6-A221-D1B4C597C71D',
	LMS_REPORTING_REPORTS_MENU_ITEM_VISIBLE: 'ACB562BA-E3BA-4789-B6CA-F4F4A55D0BAB',
	LMS_REPORTING_NOTIFICATION_RUNS_MENU_ITEM_VISIBLE: '0EACA98D-3BE3-4813-B0BD-3CC7C7D8B201',
	LMS_REPORTING_NOTIFICATION_TEMPLATES_MENU_ITEM_VISIBLE: '35D4830A-6125-4EA6-BA8D-0063195AF8F6',
	LMS_REPORTING_SETTINGS_MENU_ITEM_VISIBLE: 'C25D0FEA-A244-4A45-B73C-DAA4B5B6552A',
	LMS_REPORTING_FTP_SERVERS_MENU_ITEM_VISIBLE: '90F9D3B8-A6AD-42C5-A06B-504BD8805A9F',
	LMS_TICKETS_MENU_ITEM_VISIBLE: '29590118-002A-4417-BFDB-4D4D4F1BFB6B',
	LMS_TICKET_TYPES_MENU_ITEM_VISIBLE: '97427660-5572-4983-9650-2DB5008C6078',
	LMS_TICKET_CHECKLISTS_MENU_ITEM_VISIBLE: 'BF4E8E06-FD89-44BA-BB5E-EA746DB9722D',
	LMS_TICKET_FORMS_MENU_ITEM_VISIBLE: 'AE59C5C7-F59A-4635-AE2D-3E444397CA72',
	LMS_GENERAL_SETTINGS_MENU_ITEM_VISIBLE: '16496F70-680A-4A82-9D15-4D05FE565F35',
	LMS_INTEGRATION_SETTINGS_MENU_ITEM_VISIBLE: 'B72E800B-290B-42C6-9157-4B1E18689182',
	LMS_IMPORT_TEMPLATES_MENU_ITEM_VISIBLE: '418CA7E4-9F30-44B4-81EE-17E0DEF24FEF',
	LMS_USER_DEFINED_FIELDS_MENU_ITEM_VISIBLE: '343262C4-F469-4D92-9591-125A45155105',
	LMS_AUDIT_LOGS_MENU_ITEM_VISIBLE: 'D232802F-08A6-4833-B2CB-DAE5ECE814D3',
	LMS_WORKFLOWS_MENU_ITEM_VISIBLE: '008BCADE-F2F7-4B03-B6A1-1654C6EB55AC',
	LMS_WORKFLOW_STEPS_MENU_ITEM_VISIBLE: '48CD68B1-1B25-413B-8920-4F0761B9CDB6',
	LMS_USER_MANAGEMENT_MENU_ITEM_VISIBLE: 'CDCA7E21-ACC2-49E0-8C79-4110C9A550E1',
	LMS_GROUP_MANAGEMENT_MENU_ITEM_VISIBLE: 'E5BB6656-B931-4671-B9EE-7B3F9C8FD217',
	LMS_APPLICATION_LOG_MENU_ITEM_VISIBLE: '7C7260E5-8A62-4BC7-8FED-FC1EE352D497',
	LMS_BANK_STATEMENTS_MENU_ITEM_VISIBLE: '44EFC79B-F3BB-4424-AEA3-41A097817A24',
	LMS_BANK_IMPORTS_MENU_ITEM_VISIBLE: '788FE328-FBED-4B5B-9089-09CA886DD04C',
	LMS_BANK_ACCOUNTS_MENU_ITEM_VISIBLE: 'D5F224D9-06CA-4409-9100-9D8CDE3E90B3',
	LMS_BANK_TEMPLATES_MENU_ITEM_VISIBLE: '120F8C32-7CE6-431D-9E3B-5E27A65CB0B4',
	LMS_COLLATERAL_MENU_ITEM_VISIBLE: '737B6F9F-6EEC-4BC9-A1DB-B6E23CD6645C',
	LMS_CONTACTS_MENU_ITEM_VISIBLE: '52A9DE4A-CC36-425F-BB57-81FFDA77E9C1',

	LMS_DELETE_TRANSACTIONS: '136fb72d-c90f-4a8b-aca2-1e82b2a705ba',
	LMS_SUBMISSION_MENU_ITEM: '7e6f2b52-44a9-40af-a694-85f60bcfcf59',
	LMS_SUBMIT_LOAN: '244f2948-7308-40eb-afc9-c6cf575d7959',
	LMS_SUBMIT_ASSET: '33f02dc1-bd34-4070-9f34-924e8a8ed130',
	LMS_SETTTINGS_MANAGEMENT: '0d8739d7-24d5-4311-820b-cce2e2daa781',

	/** POD */
	POD_CONFIRM_QTY_SALESORDER: 'f6630f7b-c752-4ae3-9996-f46a0a6652c1',
	POD_MANAGE_TRIPS: '77271870-73fd-4736-8414-f27c646fb024',
	POD_ALLOW_START_MY_TRIPS: '3cc9626f-a45c-4665-866b-16d0075effff',
	POD_MANAGE_DRIVERS: 'eca8334e-174c-4b78-a417-682990814a07',
	POD_MANAGE_TRUCKS: '908dc088-8b6c-40e2-b15c-6678cbd5e67e',
	POD_DELIVER_ALL_TRIPS: '5657b55e-c688-4987-b381-b4f5eeed6016',

	LMS_LOAN_READ: 'E863637A-15EB-4A10-BD3E-A1BAB0307ECB',
	LMS_LOAN_CREATE: 'E898015C-05C2-481C-92A4-DAFD6A017DDC',
	LMS_LOAN_UPDATE: '3E61EBEC-BC48-4B40-958F-A9843CA00A16',
	LMS_LOAN_DELETE: '594F01F0-CE42-4821-9068-55E26D9A7B86',
	LMS_LOAN_RESET: 'FAF2883C-67E5-42F0-8991-FFA8C80059BB',
	LMS_LOAN_OVERVIEW_EXPORT: '00C6DBD0-BB8A-4D06-B978-D7704C94E7D0',
	LMS_LOAN_RECALC_BALANCES: 'F929F031-F81A-4702-B1CC-DC10A4B0864C',
	LMS_LOAN_RECALC_LASTCALC: '141B5173-A40B-45B9-931C-4D7AD918677B',
	LMS_LOAN_CLONE: '8BACCDDE-971A-4D68-8B32-BD4B4ECCDEDB',

	LMS_LOAN_STATUS_READ: '4CED201C-C626-49C9-A357-829CAD5DBA8D',
	LMS_LOAN_STATUS_CREATE: 'E5A8F42A-D1AF-4E37-AEF8-13A48E157766',
	LMS_LOAN_STATUS_UPDATE: 'EC6BD655-0536-4660-A401-44D39D1086B2',
	LMS_LOAN_STATUS_DELETE: 'CB04AE51-64F1-41B3-974B-E5C03E70DC4D',
	LMS_LOAN_STATUS_OVERVIEW_EXPORT: '65300788-CFDE-4DC0-BCB6-C8312F8AA38E',

	LMS_LOAN_POOL_READ: '2A9E03B3-440C-4551-AA8E-6E9E1E17FCED',
	LMS_LOAN_POOL_CREATE: '7982662F-8E4E-494A-BAE7-83A2C9F76C5C',
	LMS_LOAN_POOL_UPDATE: '43BAF1D4-2A05-4EEB-9204-B8A306FC01AF',
	LMS_LOAN_POOL_DELETE: '2FBD3A92-462C-4109-995F-AF8A0B954005',
	LMS_LOAN_POOL_OVERVIEW_EXPORT: '18472925-2F91-4CDE-9931-620F387732B6',

	LMS_PARTY_CATEGORY_READ: 'D8D71E2D-643F-487C-834F-2ED651BAA38E',
	LMS_PARTY_CATEGORY_CREATE: 'D3F95738-9B4A-486E-9A32-35450F50BAB6',
	LMS_PARTY_CATEGORY_UPDATE: '96D39632-1B9C-4AC4-B3A8-135FB4A1797E',
	LMS_PARTY_CATEGORY_DELETE: '41E5032A-F72A-4A8E-95DE-C8C3BFF56659',
	LMS_PARTY_CATEGORY_OVERVIEW_EXPORT: 'A914D430-7FBF-405E-8819-083E0C71D88E',

	LMS_PARTY_READ: '00804D5E-F0D6-45A8-9F4C-27960020D243',
	LMS_PARTY_CREATE: '32929A59-4372-41E6-BB26-007C99AB0BC5',
	LMS_PARTY_UPDATE: '8D466417-F587-4219-9685-AFF41EBC1129',
	LMS_PARTY_DELETE: 'CDA7C79B-A1BF-4F37-9AF0-79D77CDFC4AE',
	LMS_PARTY_OVERVIEW_EXPORT: '9E394713-FBE3-451C-B30B-58D150BB20DE',
	LMS_PARTY_USER_LINK_READ: '9CC57E77-4F3E-4C35-A551-DE9A21D121A0',
	LMS_PARTY_LINK_USERS: 'DACE8736-D61D-4AED-9173-EADF5F47E8A5',

	LMS_SUB_TRANSACTION_TYPE_READ: '844DE629-71D7-4EFB-B2EC-431151ED5686',
	LMS_SUB_TRANSACTION_TYPE_CREATE: '6F513BF8-F55A-4EFB-9367-3170885EB134',
	LMS_SUB_TRANSACTION_TYPE_UPDATE: 'A624003B-B7C5-4A7C-9CF1-BF5701B12162',
	LMS_SUB_TRANSACTION_TYPE_DELETE: '8CFD31E9-4E2B-4E7F-AFB1-32E490B0C765',
	LMS_SUB_TRANSACTION_TYPE_OVERVIEW_EXPORT: '499BD622-04B9-4122-B1DB-3DDE37FE9B16',

	LMS_TRANSACTION_READ: '47655A42-9AE5-479B-8E91-BCD6FBEEE589',
	LMS_TRANSACTION_CREATE_INTEREST_ADJUSTMENT: 'B8D74F7C-0744-413C-B09C-29953853D91E',
	LMS_TRANSACTION_CREATE_ADDITION_REPAYMENT: '64538E2D-9AFE-4FC2-BD7F-93344400C49C',
	LMS_TRANSACTION_UPDATE: 'F7F60F7A-4AAB-402C-BA57-80927BE36CDE',
	LMS_TRANSACTION_DELETE: '30FB7B4E-FED0-4251-BC0B-F076F511C653',
	LMS_TRANSACTION_PREVIEW: '798E8C43-DBCD-4034-AD2F-B22BD10F175A',
	LMS_TRANSACTION_POST_INTEREST_CALCULATION: 'ADC2570F-57F4-4DA8-834E-A209D34E0341',
	LMS_FX_REVALUATION: '644641DF-63AA-4646-A6C7-3FEDC634DA38',

	LMS_TRANSACTION_TYPE_READ: 'C2443A9F-7D0C-45F0-81EE-D2563988364D',
	LMS_TRANSACTION_TYPE_CREATE: '91684C05-80D4-4B1A-B64F-DED60D44CB18',
	LMS_TRANSACTION_TYPE_UPDATE: 'F868A0ED-A45C-4AD2-96D8-B4F510F5EE84',
	LMS_TRANSACTION_TYPE_DELETE: 'E1A9C9FD-9FEE-46DE-A769-27AD800F53DB',
	LMS_TRANSACTION_TYPE_OVERVIEW_EXPORT: '6A2C19D9-2EEB-4AB2-B699-284CA3EAB1C4',

	LMS_CURRENCY_READ: 'A6F6B589-502F-42FD-BF76-876985C8DFE4',
	LMS_CURRENCY_CREATE: '290B68CA-4A0A-4979-94AF-10615975B349',
	LMS_CURRENCY_UPDATE: 'F216375B-8064-4A72-9A2A-66FFA64ECF91',
	LMS_CURRENCY_DELETE: '1A9C7941-81C2-49C0-B14E-27A2182AA218',
	LMS_CURRENCY_OVERVIEW_EXPORT: '8B8555D7-44BF-47A8-8EB5-C5F41386DB4F',

	LMS_CURRENCY_RATES_READ: 'CFCFC95F-D0B7-4280-B90F-358E13BEC13A',
	LMS_CURRENCY_RATES_CREATE: '032091DE-8FBB-44CE-95AA-E7C23FAC32D5',
	LMS_CURRENCY_RATES_UPDATE: '4C222564-4AB0-4A1C-A51D-9E7E6AB9859C',
	LMS_CURRENCY_RATES_DELETE: '76969EB3-EB3D-4873-8E7E-DC0F65ED1F8D',
	LMS_CURRENCY_RATES_OVERVIEW_EXPORT: '5F64C36A-0A74-4546-87C2-E8CD90B1707D',

	LMS_HOME_SETTINGS_READ: '8A973DCB-1991-4460-8850-241105380693',
	LMS_HOME_SETTINGS_CREATE: '310D33BF-9691-4082-8A28-3FCE0859E8E0',
	LMS_HOME_SETTINGS_UPDATE: '2D827854-7AE7-4A96-84EB-A4EF67EDBD1C',
	LMS_HOME_SETTINGS_DELETE: '2C4F68CB-2683-43DA-8A23-E5FF140B56D1',

	LMS_INTEREST_TYPE_READ: '60036346-C780-4C29-86E1-ED6A0712B9C8',
	LMS_INTEREST_TYPE_CREATE: 'E3D91FD5-5A7B-4F73-BFB4-5988A358B4C5',
	LMS_INTEREST_TYPE_UPDATE: '9BE89C8A-E9FE-4235-B809-755E8E3B63E6',
	LMS_INTEREST_TYPE_DELETE: 'F0038744-B12A-4C94-A0E1-085C8C97CF64',
	LMS_INTEREST_TYPE_OVERVIEW_EXPORT: 'D93FE751-734D-41E3-968D-3062B74C5192',

	LMS_INTEREST_TYPE_RATE_READ: '8113796B-3B00-42E4-8201-528C5A3D48BF',
	LMS_INTEREST_TYPE_RATE_CREATE: 'AE015BE3-76EA-4C52-A142-0FB1BCACDF59',
	LMS_INTEREST_TYPE_RATE_UPDATE: '2AEE3711-74EC-485B-BFDC-3AE7AEFABBE5',
	LMS_INTEREST_TYPE_RATE_DELETE: '974ECB66-C57F-480D-BE46-17E79FD280A1',
	LMS_INTEREST_TYPE_RATE_OVERVIEW_EXPORT: '4F1AFD80-2ADD-4D3F-8522-1376E1AA407A',

	LMS_LOAN_INTEREST_TYPE_READ: 'EB6E4459-7632-46EA-84B1-6C6213A6CE69',
	LMS_LOAN_INTEREST_TYPE_CREATE: 'DE921F27-3DEE-4F83-85DB-E4EC28823E60',
	LMS_LOAN_INTEREST_TYPE_UPDATE: '89BCAF85-146B-49EA-9EDB-10344AD78C74',
	LMS_LOAN_INTEREST_TYPE_DELETE: 'CD55B360-3DFE-4545-8118-3199072280CC',

	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_READ: '66266FAA-1355-4C30-8968-2EB14AE40A6A',
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_CREATE: '39B4B3F3-8A96-4572-BF65-14D006B0194D',
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_UPDATE: 'DE9DC4D9-2287-497C-A454-2D4664016D1B',
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_DELETE: '7B41FE2F-954A-464F-BF88-C3D82CC0799D',
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_GENERATE: '56578EE6-B181-4852-9F5D-325BB77D8702',
	LMS_LOAN_INTEREST_TYPE_VARIABLE_RATE_RESET: 'E715C445-D407-4145-A6FA-70F0280F85D7',

	LMS_COMPOUND_CALENDAR_READ: '1C86DECE-C6ED-4EF8-9A69-A71455D3EA7E',
	LMS_COMPOUND_CALENDAR_CREATE: '37427D5B-1B90-40E8-B652-33224523632A',
	LMS_COMPOUND_CALENDAR_UPDATE: '8F33A610-E314-4EF9-B704-822A50E34AF1',
	LMS_COMPOUND_CALENDAR_DELETE: '8128A860-1FA4-4F42-BF2D-49417F736B94',
	LMS_COMPOUND_CALENDAR_GENERATE: '72DE20E4-B1B3-4A89-9EF7-C89038BEC6A3',
	LMS_COMPOUND_CALENDAR_RESET: 'F8069332-A668-4AF4-911E-D7A80633085B',

	LMS_PAYMENT_DATE_CALENDAR_READ: 'A2D38E02-76E7-4687-A918-EC222A090797',
	LMS_PAYMENT_DATE_CALENDAR_CREATE: 'E76A935D-04AB-4EA3-8382-78C9E8514635',
	LMS_PAYMENT_DATE_CALENDAR_UPDATE: 'ED63C64E-5671-423D-A8C9-27DCD5D762A1',
	LMS_PAYMENT_DATE_CALENDAR_DELETE: '62DFDA11-39F9-498F-9ECF-6098DECD8215',
	LMS_PAYMENT_DATE_CALENDAR_GENERATE: '0E1D998A-2364-4249-BC80-CEBDE6A0010E',
	LMS_PAYMENT_DATE_CALENDAR_RESET: '49D88F0A-13EF-4111-A6EC-C481671C8E56',

	LMS_CALCULATION_STEP_READ: 'E7431D3F-F8B3-486E-ADCC-88B8145A7B7B',
	LMS_CALCULATION_STEP_PREVIEW: 'B404EBEA-B7DD-4CD6-AC8C-5BB83EE5EF98',
	LMS_CALCULATION_STEP_APPEND_PREVIEW: '98A69E24-7863-4B2A-A166-295933FDBB21',

	LMS_DAYCOUNT_CONVENTION_READ: 'A318FF68-B0C3-4F54-9559-B715512E26EB',

	LMS_CALCULATE_INTEREST: '707923E9-2ADB-4B95-9513-19DD849D38EA',

	LMS_DEFAULTING_TEMPLATE_READ: '75769AE2-EA9B-42E8-8EB0-C2DB0A0E5B2F',
	LMS_DEFAULTING_TEMPLATE_CREATE: '6ED16CC2-CCF2-40D8-8810-22B66DCB34D1',
	LMS_DEFAULTING_TEMPLATE_UPDATE: '88035488-FE6E-4AEA-914E-AAA2458C530C',
	LMS_DEFAULTING_TEMPLATE_DELETE: '2E2009E9-4859-4CE4-B190-1C0A92205043',

	LMS_VARIABLE_FIXED_AMOUNT_READ: '03F4F2D9-195A-4748-9DCA-0CC6406FB361',
	LMS_VARIABLE_FIXED_AMOUNT_CREATE: '1FC9E71A-4465-4ACA-82B0-99E29E3D4C97',
	LMS_VARIABLE_FIXED_AMOUNT_UPDATE: '4E11FA7C-A7CA-4E37-8EF9-D688C0340566',
	LMS_VARIABLE_FIXED_AMOUNT_DELETE: '498FAFD4-E4BD-445A-A753-370E088147A6',

	LMS_REPAY_VARIABLE_INTEREST_RATE_CREATE: '929BEB89-610A-416B-8C3B-C6590E362664',
	LMS_REPAY_VARIABLE_INTEREST_RATE_READ: 'D5255D12-279B-409B-9BB5-8E344A02DCAC',
	LMS_REPAY_VARIABLE_INTEREST_RATE_UPDATE: '2EF82497-81CE-4FE5-A598-A2E3F94C0088',
	LMS_REPAY_VARIABLE_INTEREST_RATE_DELETE: '0D0993E4-6369-4937-A3D4-4E4ACACCCC2A',
	LMS_REPAY_VARIABLE_INTEREST_RATE_GENERATE: '355777C5-51B2-4F7E-A699-E291D04BE047',
	LMS_REPAY_VARIABLE_INTEREST_RATE_RESET: 'F3570009-9DAB-4E1F-97AE-5AA1CB7200E6',

	LMS_LOAN_REPAYMENT_CONFIG_CREATE: 'D7D25774-7D57-4DB8-ADD1-C9C26A093A19',
	LMS_LOAN_REPAYMENT_CONFIG_READ: 'E3D38F35-7315-4DE8-9042-BADBEE7F4715',
	LMS_LOAN_REPAYMENT_CONFIG_UPDATE: 'DAF8F1B5-53D6-46F5-A8A5-1C27753DF679',

	LMS_LOAN_REPAYMENT_HOLIDAY_CREATE: '9A5F8611-E226-4772-BF6A-27507817126D',
	LMS_LOAN_REPAYMENT_HOLIDAY_READ: 'ACB359D2-9987-452C-AC77-6EBAA9726CEB',
	LMS_LOAN_REPAYMENT_HOLIDAY_UPDATE: 'BE7083AB-2446-44B0-8E06-BC313104B328',
	LMS_LOAN_REPAYMENT_HOLIDAY_DELETE: '3053B82A-B917-432E-9292-E7DAA4906308',

	LMS_AUDIT_LOG_READ: '9920F709-7D66-46CC-8809-8716586DD3B2',

	LMS_POST_TO_INTEGRATION: 'F59DF01D-0828-437F-932F-DD03BB777AE2',
	LMS_INTEGRATION_CREATE_PARTY: '37795F18-12DC-40BF-B25B-CA5314CD3D24',
	LMS_INTEGRATION_SYNC: '11497DBE-0F1E-41F7-93B7-F2715AA9FBD2',
	LMS_INTEGRATION_SETTINGS_READ: '65816510-0F30-400B-A213-2E903C1FADD1',
	LMS_INTEGRATION_SETTINGS_UPDATE: '012F2F39-28B8-438B-ADAA-0A449FCED49A',

	LMS_REFRESH_DATABASE: 'C5B23DE4-E3A2-4C01-8746-2DF17BC25443',

	LMS_IMPORT_TEMPLATE_READ: '9310CB68-93B9-4581-9528-851E5F723D29',
	LMS_IMPORT_TEMPLATE_CREATE: '48C12B5A-E3CB-4405-B1BD-FB4EF15F7BE0',
	LMS_IMPORT_TEMPLATE_UPDATE: 'D6B85085-05D7-4700-952D-AB89368AE224',
	LMS_IMPORT_TEMPLATE_DELETE: 'B71BCBED-C806-4608-B890-8271A565F57D',

	LMS_BATCH_REQUEST_READ: '41CECADC-C2C4-4939-9900-A019A07950F7',
	LMS_BATCH_REQUEST_CREATE: 'ECB0F46E-176C-4ACF-A6FC-8F1FBB633A56',
	LMS_BATCH_REQUEST_UPDATE: '676EE3F3-D34E-4DD2-AA8F-2EE5E38BB29B',
	LMS_BATCH_REQUEST_DELETE: 'CE95D3A5-8D15-4952-87F0-0F16A4A13211',

	LMS_VALIDATION_READ: '31EA48EB-B4A0-4046-940B-F34C47476127',
	LMS_VALIDATION_CREATE: '288BA111-CB86-495A-9A45-9709851F037F',
	LMS_VALIDATION_UPDATE: '8B4E388C-34FB-4394-B888-D0345A3FE10F',
	LMS_VALIDATION_DELETE: '6183B9D3-9AFD-4308-BD99-E15C797EAF09',
	LMS_VALIDATION_RUN: 'F080A7F3-1636-422C-B507-EA22C97EEF74',

	LMS_HOLIDAY_SCHEDULE_CREATE: 'A77191F5-5A4A-4D2E-848C-33AD72AD61FC',
	LMS_HOLIDAY_SCHEDULE_READ: '2CFD86AC-A355-4363-BCA8-DBC6E4CC1267',
	LMS_HOLIDAY_SCHEDULE_UPDATE: 'F5B04760-2C6C-42DD-840E-3AE91A8AD823',
	LMS_HOLIDAY_SCHEDULE_DELETE: 'B272413E-0D6E-4250-BBC8-86144DB87CEB',

	LMS_HOLIDAY_SCHEDULE_DATE_CREATE: 'B3535B6D-F665-453C-9202-41AE7764D235',
	LMS_HOLIDAY_SCHEDULE_DATE_READ: '876343CA-3349-4D3C-8C6F-D3C5D283E1C5',
	LMS_HOLIDAY_SCHEDULE_DATE_UPDATE: '3649DD4C-100A-4AFC-B969-053D4A1F8318',
	LMS_HOLIDAY_SCHEDULE_DATE_DELETE: '2B801328-07DC-45E7-8BF8-84CC2114C09E',

	LMS_LOAN_PRODUCT_CREATE: 'E0B8C2B8-9B76-4D49-86E0-45E817F97FA3',
	LMS_LOAN_PRODUCT_READ: 'FADC69C7-661B-4366-BDB2-6CCAAF5E1AE2',
	LMS_LOAN_PRODUCT_UPDATE: '966B1357-6120-4C14-951D-EFBAA922A65B',
	LMS_LOAN_PRODUCT_DELETE: 'B9245A67-B3BB-4321-8E45-41A990AB2A5E',
	LMS_LOAN_PRODUCT_BYPASS: '1839954A-545B-48AB-8CB3-7E50A8D9EEB0',

	LMS_UDF_READ: '53651F87-EC4F-4E90-AACC-D208A86E887D',
	LMS_UDF_CREATE: 'C6646D9F-90A9-41CD-B6F7-290A67CDC6C5',
	LMS_UDF_EDIT: '1978B312-0CC6-44BD-936B-78B2D9A69558',
	LMS_UDF_DELETE: '515711A1-6640-4475-BD9E-92E27E4D888E',

	RF_CREATE: '275A0FBD-CA8D-49CF-9731-6E92EE2996A6',
	RF_READ: '1A76223E-40ED-45D0-9B0C-3393AF552A66',
	RF_UPDATE: '859D374A-270A-40AC-8C73-1B9854079617',
	RF_DELETE: 'DD257615-52F6-4D28-AC18-77E258AB38AC',
	RF_SUBMIT_INTERN: '6411934D-3E71-429A-8F9D-2AE87616EE39',
	RF_TO_AUTHORIZE: '0BBE67B8-0A43-4047-A88F-A152584CCF55',
	RF_SUBMISSION_READ: '82FD3E5C-77CC-468B-BD45-9EBBF3D7BF05',

	EVO_SCANNER_SETTTINGS_MANAGEMENT: '4686A735-0884-45D1-AD2E-6AABE4F6D558',

	LOCATION_CREATE: '8AC37B29-BF03-4306-BFC2-D2F02AD49008',
	LOCATION_READ: 'C976A7C3-1EFF-4C56-8214-D9CE5158A331',
	LOCATION_UPDATE: '4D101FAC-61E2-42D5-AECB-3A2DCE0E8961',
	LOCATION_DELETE: '5AC93CCB-A356-49E7-87F6-0786F944750F',

	SCAN_CREATE: 'C95AB21B-F8A8-48D3-ADF0-87CF5951E8B0',
	SCAN_READ: '36BDDF54-B6C9-46F3-9125-A4AAB3A68A31',

	LMS_DIRECT_DEBIT_CREATE: '600E62C9-1DBC-4CAE-949A-597569F71B20',
	LMS_DIRECT_DEBIT_READ: 'C1CE2447-C6C5-48EB-A13C-682D34F93960',
	LMS_DIRECT_DEBIT_UPDATE: '3F4CEAEC-1EE7-4D0F-A284-D1B4EA1777B2',
	LMS_DIRECT_DEBIT_DELETE: 'CDCB4822-400C-494D-A83C-77077386EA97',
	SCAN_EMAIL_JOB_CREATE: 'B037BD2F-590C-497E-8AE5-ABB802B0717A',

	SCAN_EMAIL_JOB_READ: '20F8AB04-BB1E-459E-A3BF-B6AD43C619C7',
	SCAN_EMAIL_JOB_UPDATE: '278FEC78-7AD7-4C6E-912D-B87FB47BF694',
	SCAN_EMAIL_JOB_DELETE: '1E0A2469-F8B2-451B-AA2F-46F8932C7AF5',

	LMS_BANK_ACCOUNT_CREATE: '06D534DE-E983-440F-B7B3-BFE34BAEA20A',
	LMS_BANK_ACCOUNT_READ: '67254941-C835-4F64-8F4D-3409AF8E6FF4',
	LMS_BANK_ACCOUNT_UPDATE: '08A924F4-61C3-439F-8DC0-34C4C585769F',
	LMS_BANK_ACCOUNT_DELETE: 'AA5D2318-A67C-415C-BAEB-E26A984090EC',

	LMS_BANK_TEMPLATE_CREATE: '5D00DA46-2AFF-4F59-B19A-76EFBC7D984F',
	LMS_BANK_TEMPLATE_READ: '8042D4EA-E833-4AF2-BEB6-9B18112570E3',
	LMS_BANK_TEMPLATE_UPDATE: '20081D92-DB5D-4DEE-B6F0-2B442DE1BD1E',
	LMS_BANK_TEMPLATE_DELETE: 'DF22A61B-EBBB-45F6-B37D-20275C6A5442',

	LMS_BANK_IMPORT: '3B68C70A-0A8C-4022-B125-11EDD8390367',

	LMS_DISBURSEMENT_CREATE: '85B044B2-4050-4DF7-9357-34483AAA71FB',
	LMS_DISBURSEMENT_READ: '8D87F035-694D-4BF1-B4DF-2E2B5C53CB47',
	LMS_DISBURSEMENT_READ_DETAILS: 'B97A8281-67A7-4B42-B222-31302BA9EB62',
	LMS_DISBURSEMENT_UPDATE: 'DBCE341A-C4C0-40C6-B4C5-734C85E6D8EA',
	LMS_DISBURSEMENT_DELETE: '73DE7999-3FB6-420E-AC6D-6068A9D2700C',
	LMS_DISBURSEMENT_VIEW_WIDGET: 'F93DA69D-DDB2-4897-A59E-30F89DC04F3E',
	LMS_DISBURSEMENT_PROCESS: '07DD8C57-6A6B-4DE6-8068-7CCBC5A11D4B',
	LMS_DISBURSEMENT_CANCEL: 'E0DEF3E2-ACD7-46B7-86AD-88C0522C9231',

	LMS_COLLATERAL_READ: '5F56886B-F2F7-4D21-BBDB-E7CDBE71CFCE',
	LMS_COLLATERAL_CREATE: 'C2E60861-F79E-4A34-BAE7-54365D4D8630',
	LMS_COLLATERAL_UPDATE: '3BDD02F2-144E-48C9-94E5-34614CA06CCB',
	LMS_COLLATERAL_DELETE: '8805E617-EA65-4CA8-B2B3-49EECEA48607',

	LMS_INFORMATIONAL_SCHEDULE_READ: 'DB4EBAC6-DFAC-49D3-BC94-13B9D193F164',
	LMS_INFORMATIONAL_SCHEDULE_GENERATE: '01A1E3EF-2B9F-4B84-AFB8-16FC493A3844',

	LMS_OPERATIONAL_DASHBOARD_CARDS_READ: 'D8DE14CD-5F00-4B0D-8BC4-0F1AEB7562A9',
	LMS_CLIENT_DASHBOARD_CARDS_READ: 'BC70F60B-C449-4611-8E08-41FBE90E5ED5',
	LMS_CLIENT_KPI_READ: '8504BFA6-5A3A-4A8D-BFF5-66A3BD807992',
	LMS_SETTINGS_REFRESH: 'E2F015C1-F02C-4520-98C9-B16E901775FF',
	LMS_SETTINGS_RESET: '4ED9FC43-C331-4BD5-B13E-48EE6ECD2802',
	LMS_DEFAULT_WF_CREATE: 'C2CB4744-6361-4C87-A7FB-DADF61E7F490',

	LMS_KYC_FORMS_READ: '3BEDEDB8-8AB3-42DC-A69A-A1549DAA0D8C',
	LMS_KYC_PROVIDER_READ: '0E95F809-9DCF-4645-AC22-215A6526E080',
	LMS_KYC_CHECK_READ: 'A8AE30A0-8565-4CDA-AC2F-85BC07F1A81E',
	LMS_KYC_CHECK_UPDATE: 'A9A44A26-4E98-46A5-9814-B11A65F6930D',
	LMS_KYC_CHECK_INITIATE: '516FF5A1-FEDD-48EF-A775-A220EB30FC6B',

	LMS_TRANSACTION_IMPORT_READ: '9162247F-C29C-4065-A115-64464941A1A6',

	LMS_PARTY_FS_CREATE: 'FDE6889A-369A-4A62-8F7E-B5293AC8A5BE',
	LMS_PARTY_FS_READ: 'C69B226A-118B-4148-A59C-8B4C59150EFC',
	LMS_PARTY_FS_UPDATE: '5535C62D-7A18-4DC2-BC34-D917CA829300',
	LMS_PARTY_FS_DELETE: '71A7C0D0-EDEF-4178-8B05-55DBEF7EAFB5',

	LMS_AUDIT_LOG_READ_ALL: '9920F709-7D66-46CC-8809-8716586DD3B2',

	// Batch imports
	BATCH_TEMPLATE_READ: '9310CB68-93B9-4581-9528-851E5F723D29',
	BATCH_TEMPLATE_CREATE: '48C12B5A-E3CB-4405-B1BD-FB4EF15F7BE0',
	BATCH_TEMPLATE_UPDATE: 'D6B85085-05D7-4700-952D-AB89368AE224',
	BATCH_TEMPLATE_DELETE: 'B71BCBED-C806-4608-B890-8271A565F57D',

	BATCH_REQUEST_READ: '41CECADC-C2C4-4939-9900-A019A07950F7',
	BATCH_REQUEST_CREATE: 'ECB0F46E-176C-4ACF-A6FC-8F1FBB633A56',
	BATCH_REQUEST_UPDATE: '676EE3F3-D34E-4DD2-AA8F-2EE5E38BB29B',
	BATCH_REQUEST_DELETE: 'CE95D3A5-8D15-4952-87F0-0F16A4A13211',

	// Syndicated loans
	LMS_SYNDICATES_CREATE_LENDER: '769EC888-7D87-4F56-B74B-72575D6964F6',
	LMS_SYNDICATES_ASSIGN: 'F709BBE8-175D-4F28-A7E5-A420C4C9FE1B',
	LMS_SYNDICATES_SEND_NOTIFICATION: 'E65D7A03-2673-4F5C-A648-C0A8FF3617E5',

	// Contacts
	LMS_CONTACTS_READ: 'C6677C53-3FC4-4C86-8661-CFC6CB6AF893',
	LMS_CONTACTS_CREATE: '9841432C-0F6A-41BD-A33A-B6B794054867',
	LMS_CONTACTS_UPDATE: 'F43A57DF-A89A-46D1-923F-E52FC79F48B1',
	LMS_CONTACTS_DELETE: '093FE1F4-29BE-4789-A04D-721C626400E4',
	LMS_CONTACTS_LINK: 'DC710ACD-C59F-49CB-ACDA-C48195EB2E43',
};
